// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-23T21:41:08.010Z
// Property: Cedar Creek Crossing Apartments (ID: 6767906449167514)
// Collections: 26 amenities, 2 floorplans (live), 48 photos, 41 POIs, 3 reviews, 2 virtual tours, 5 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162458",
  "multihub_property_id": "6767906449167514",
  "property_external_id": "5685512",
  "property_zillow_url": "https://www.zillow.com/b/2225-n-12th-st-quincy-il-5XtNwT/",
  "property_apartments_url": "https://www.apartments.com/cedar-creek-crossing-apartments-quincy-il/d5q54zk/",
  "property_google_business_url": "https://www.google.com/maps/place/Cedar+Creek+Crossing+Apartments/@39.95868,-91.397007,908m/data=!3m2!1e3!4b1!4m6!3m5!1s0x87ddf7ceddb755d3:0x8b89da5af0b820f9!8m2!3d39.95868!4d-91.397007!16s%2Fg%2F1tdxldy3?entry=ttu&g_ep=EgoyMDI2MDUyNi4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": "57248415648",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "cedar-creek-crossing-apartments",
  "property_name": "Cedar Creek Crossing Apartments",
  "property_website_url": "https://www.cedar-creek-crossing.com/",
  "property_domain": "https://www.cedar-creek-crossing.com/",
  "property_address": "2225 N 12th St",
  "property_full_address": "2225 N 12th St, Quincy, IL 62305",
  "property_address_1": "2225 N 12th St",
  "property_address_2": null,
  "property_address_city": "Quincy",
  "property_address_state": "IL",
  "property_address_zip_full": "62305-1360",
  "property_address_zip": "62305",
  "property_address_country": "US",
  "property_address_county": "Adams County",
  "property_neighborhood_address": "Effingham/Central Illinois Area",
  "property_address_latitude": "39.9588833",
  "property_address_longitude": "-91.39773389999999",
  "property_email": "cedarcreekcrossing@dietzpropertygroup.com",
  "property_phone": "(217) 228-3011",
  "property_call_tracking_phone": "217-334-4186",
  "property_company_name": "Dietz Property Group",
  "property_company_url": "https://www.dietzpropertygroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Cedar Creek Crossing in Quincy, IL, where comfort meets convenience. Choose from our spacious two and three-bedroom floor plans and enjoy top-notch amenities managed by our professional on-site staff. Embrace a vibrant lifestyle and make lasting memories—find your new home today by browsing our availability or scheduling a tour!",
  "property_long_description": "Welcome to Cedar Creek Crossing, your ideal apartment community nestled in the heart of Quincy, IL. We are proud to offer a selection of stunning two and three-bedroom floor plans designed to enhance your lifestyle and provide the perfect blend of comfort and convenience. Each apartment features spacious layouts and modern finishes, making it easy to find a home that perfectly suits your needs.\n\nAt Cedar Creek Crossing, our commitment to exceptional living extends beyond just our apartments. Our community offers a host of amenities tailored to ensure you enjoy a relaxed and fulfilling lifestyle. From expertly landscaped grounds to inviting common areas, we provide the perfect backdrop for creating lasting memories. Plus, our professional, on-site management staff is dedicated to providing top-notch service, making your living experience as seamless as possible.\n\nDon’t miss your chance to call Cedar Creek Crossing home! Whether you're searching for a cozy two-bedroom or a spacious three-bedroom apartment, we have options to meet your requirements. Explore our full range of floor plans and discover the perfect living space for you and your family.\n\nFind your new home today! Browse our availability or schedule a tour to visit our vibrant community. Come experience the warmth and charm of Cedar Creek Crossing—where your ideal lifestyle awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-6ca9-73ff-af3b-373047288196.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of apartment building with stone accents and balconies.",
    "public_id": "019e8ef7-6ca9-73ff-af3b-373047288196",
    "storage_key": "property/6767906449167514/019e8ef7-6ca9-73ff-af3b-373047288196.webp",
    "width": 1800,
    "height": 1200
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "80",
  "property_year_built": "2002",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "100",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": "200",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "40",
  "property_pet_restrictions": "Maximum 2 animals per unit. Breed restrictions apply (e.g., no Pit Bulls, Rottweilers, German Shepherds, etc.). All pets must be spayed/neutered, over one year old, licensed, inoculated, and accompanied by veterinarian certification.",
  "property_pet_policy_description": "We accept cats and dogs. One-time pet fee: $200 per pet. Monthly pet rent: $25 per pet. Maximum of 2 pets per apartment home. There is no weight limit. Breed restrictions apply.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://cedarcreekcrossing.loftliving.com/",
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019ef547-7a37-70e2-be8f-fa3836c9ea3d.webp",
  "property_primary_logo_media": {
    "alt_text": "Cedar Creek Crossing Apartments logo",
    "public_id": "019ef547-7a37-70e2-be8f-fa3836c9ea3d",
    "storage_key": "property/6767906449167514/019ef547-7a37-70e2-be8f-fa3836c9ea3d.webp",
    "width": 2000,
    "height": 2000
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019dffdc-8ac5-716c-b71f-1f453648e537.webp",
  "property_icon_media": {
    "alt_text": "DPG logo",
    "public_id": "019dffdc-8ac5-716c-b71f-1f453648e537",
    "storage_key": "company/5767906449162458/019dffdc-8ac5-716c-b71f-1f453648e537.webp",
    "width": 344,
    "height": 329
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019dffdc-8ac5-716c-b71f-1f453648e537.webp",
  "property_fav_icon_media": {
    "alt_text": "DPG logo",
    "public_id": "019dffdc-8ac5-716c-b71f-1f453648e537",
    "storage_key": "company/5767906449162458/019dffdc-8ac5-716c-b71f-1f453648e537.webp",
    "width": 344,
    "height": 329
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019ef547-7a37-70e2-be8f-fa3836c9ea3d.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Cedar Creek Crossing Apartments logo",
    "public_id": "019ef547-7a37-70e2-be8f-fa3836c9ea3d",
    "storage_key": "property/6767906449167514/019ef547-7a37-70e2-be8f-fa3836c9ea3d.webp",
    "width": 2000,
    "height": 2000
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019ef547-7a9a-723a-93c1-a42fd1ee0ad7.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Cedar Creek Crossing Apartments logo",
    "public_id": "019ef547-7a9a-723a-93c1-a42fd1ee0ad7",
    "storage_key": "property/6767906449167514/019ef547-7a9a-723a-93c1-a42fd1ee0ad7.webp",
    "width": 2000,
    "height": 2000
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019dffdc-8ac5-716c-b71f-1f453648e537.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019d638a-0da7-727f-ad43-3bd78629f61b.webp",
  "property_company_logo_media": {
    "alt_text": "Dietz Property Group logo",
    "public_id": "019d638a-0da7-727f-ad43-3bd78629f61b",
    "storage_key": "company/5767906449162458/019d638a-0da7-727f-ad43-3bd78629f61b.webp",
    "width": 992,
    "height": 329
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019e28a2-379b-72ca-a5a9-1262d569a77e.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "DPG logo",
    "public_id": "019e28a2-379b-72ca-a5a9-1262d569a77e",
    "storage_key": "company/5767906449162458/019e28a2-379b-72ca-a5a9-1262d569a77e.webp",
    "width": 344,
    "height": 329
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019e28a2-7e6e-752b-a7e2-54f21a5cd171.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "DPG logo in white on black background.",
    "public_id": "019e28a2-7e6e-752b-a7e2-54f21a5cd171",
    "storage_key": "company/5767906449162458/019e28a2-7e6e-752b-a7e2-54f21a5cd171.webp",
    "width": 344,
    "height": 329
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#ffffff",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#757B77",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 3",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "960 - 1100",
  "property_sqft_min": "960",
  "property_sqft_max": "1100",
  "property_price_range": "300 - 1085",
  "property_price_min": "300",
  "property_price_max": "1085",
  "property_available_units": 6,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ01W33c733YcR-SC48FraiYs",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?cflt=apartments&find_loc=Quincy%2C+IL",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Cedar Creek Crossing",
  "property_home_romance_title": "Embrace Comfort and Connection in Your New Apartment Home",
  "property_home_amenities_blurb": "<p>Welcome to Cedar Creek Crossing in Quincy, IL, where spacious, affordable two and three-bedroom floor plans meet exceptional amenities. With dedicated on-site management, your comfort is our priority. Uncover the perfect blend of style and convenience, tailored for modern living in a vibrant community—your ideal home awaits!</p>",
  "property_home_floorplans_blurb": "At Cedar Creek Crossing in Quincy, IL, choose from spacious two and three-bedroom apartments designed for modern living. With thoughtfully crafted layouts and ample amenities, every corner of your new home invites comfort and style. Browse our available apartment homes today and find the floor plan that suits your lifestyle!",
  "property_home_gallery_blurb": "At Cedar Creek Crossing in Quincy, IL, upscale living meets unparalleled comfort. Choose from spacious two- and three-bedroom floor plans, all while enjoying exceptional amenities and the care of our dedicated on-site management staff. Picture yourself living here, where every detail is crafted for your optimal lifestyle!",
  "property_home_neighborhood_blurb": "<p>At Cedar Creek Crossing, our affordable housing in Quincy, IL effortlessly blends urban convenience with serene living. Nestled near educational hubs like Quincy University and John Wood Community College, plus recreational gems like Flinn Memorial Stadium and the Quincy Children's Museum, our community is the ultimate launchpad for your adventures. Explore local treasures today!Pets</p>",
  "property_home_reviews_blurb": "At Cedar Creek Crossing in Quincy, IL, residents rave about the “welcoming atmosphere and spacious apartments.” Experience a vibrant community where comfort meets convenience. Dive into the genuine stories of your future neighbors and see what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At Cedar Creek Crossing in Quincy, IL, life effortlessly blends urban convenience with serene living. Nestled near educational hubs like Quincy University and John Wood Community College, plus recreational gems like Flinn Memorial Stadium and the Quincy Children's Museum, our community is the ultimate launchpad for your adventures.  Explore local treasures today!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>At Cedar Creek Crossing, our two and three-bedroom floor plans are designed for modern living. Enjoy exceptional amenities and the support of our professional on-site management team, all within a vibrant, affordable housing community in Quincy, IL that feels like home. Come experience the perfect blend of comfort and convenience!</p>",
  "property_applynow_blurb": "<p>Looking for the best affordable apartments in Quincy, IL? At Cedar Creek Crossing, vibrant living awaits with our spacious two and three-bedroom floor plans tailored for your lifestyle. Enjoy top-notch amenities and the support of our professional on-site management team. Your ideal home is just a click away—lease online today and start your new chapter!</p>",
  "property_contactus_blurb": "<p>At Cedar Creek Crossing, our thoughtfully designed two and three-bedroom floor plans cater to your lifestyle. We offer tax credit apartments in Quincy, IL. Whether you crave spacious living or cozy nooks, we have the perfect space for you. Need assistance? Reach out to our friendly leasing team today for personalized support!</p>",
  "property_faqs_blurb": "At Cedar Creek Crossing in Quincy, IL, our diverse floor plans, including spacious two and three-bedroom options, cater to every lifestyle. Whether you're seeking comfort or convenience, our community has what you need. Visit our FAQs page to uncover essential insights into life at Cedar Creek Crossing!",
  "property_floorplans_blurb": "<p>At Cedar Creek Crossing in Quincy, IL, our thoughtfully affordable two and three-bedroom apartments offer spacious living tailored to your lifestyle. Experience comfort and convenience while embracing a vibrant community. Browse our available apartment homes today and uncover the perfect floor plan that fits your vision of home.</p>",
  "property_gallery_blurb": "<p>Cedar Creek Crossing is proud to be one of the top choices among Quincy, IL affordable apartments. Envision your ideal home with our spacious two and three-bedroom floor plans. Enjoy exceptional amenities and the support of our dedicated on-site management team. Browse our photo gallery and picture yourself living in the perfect blend of comfort and community!</p>",
  "property_interactivemap_blurb": "At Cedar Creek Crossing in Quincy, IL, find your perfect sanctuary with our spacious two and three-bedroom floor plans. Enjoy exceptional amenities and the expertise of our professional on-site management team, ensuring a seamless living experience. Use our interactive community map to uncover your next home sweet home!",
  "property_pets_blurb": "<p>At Cedar Creek Crossing, our pet-friendly, affordable apartment community in Quincy, IL mean your furry friends are part of the fun! Embrace a vibrant lifestyle in our pet-friendly community where two pets per unit can enjoy spacious living. With a perfect blend of comfort and convenience, your four-legged companions will love it here as much as you do!</p>",
  "property_referafriend_blurb": "At Cedar Creek Crossing in Quincy, IL, our spacious two and three-bedroom floor plans are designed for comfort and style. Share the joy of vibrant living and refer a friend to join our welcoming community. Great friends make great neighbors—help someone find their perfect home today!",
  "property_residentaccess_blurb": "Welcome to Cedar Creek Crossing in Quincy, IL, where your comfort meets convenience. Choose from our spacious two or three-bedroom floor plans tailored for your lifestyle. Unlock seamless living by accessing your resident portal to easily pay rent, schedule maintenance, and connect with your community today!",
  "property_reviews_blurb": "At Cedar Creek Crossing in Quincy, IL, residents rave about the \"welcoming atmosphere and friendly staff.\" This vibrant community is more than just a place to live—it's a home filled with warmth and camaraderie. See what our residents have to say about living here and join our thriving community!",
  "property_created_at": "1779305794485",
  "property_scheduletour_blurb": "<p>Tour our best affordable apartments in Quincy, IL, along with our spacious two-bedroom homes, at Cedar Creek Crossing. With a variety of floor plans designed for comfort and style, your new home is just a tour away. Learn more about our tax credit apartmetns in Quincy, IL!</p>",
  "property_thankyou_blurb": "Thank you for sharing your interest in Cedar Creek Crossing in Quincy, IL! Our spacious two and three-bedroom floor plans are designed for comfort and modern living. A member of our team will be in touch soon to help you find your ideal home. We can't wait to connect!",
  "property_virtualtours_blurb": "<p>Take a virtual tour of affordable two and three-bedroom apartments in Quincy, IL, at Cedar Creek Crossing. Experience comfort and style throughout our community. Dive into the ambiance of your future home—take a virtual tour today and see what makes Cedar Creek Crossing truly special!</p>",
  "property_copyright": "2026 All Rights Reserved. Cedar Creek Crossing",
  "property_seo_title_home": "Affordable Apartments in Quincy, IL | Cedar Creek Crossing",
  "property_seo_description_home": "Cedar Creek Crossing offers 2 & 3-bedroom apartments in Quincy, IL, near Downtown Quincy, Quincy University, & Blessing Health System. Visit our website today!",
  "property_seo_title_floorplans": "2- and 3-Bedroom Affordable Apts in Quincy, IL | Floor Plans",
  "property_seo_description_floorplans": "Explore spacious 2- and 3-bedroom apartments in Quincy, IL with open layouts designed for comfort and convenience near Downtown Quincy.",
  "property_seo_title_amenities": "Pet-Friendly Affordable Apartments in Quincy, IL | Amenities",
  "property_seo_description_amenities": "Cedar Creek Crossing offers convenient amenities and features. Enjoy a pool, fitness center, laundry facilities, and pet-friendly apartments in Quincy, IL.",
  "property_seo_title_gallery": "Affordable Apartments for Rent in Quincy, IL | Gallery",
  "property_seo_description_gallery": "Explore photos of Cedar Creek Crossing apartments and community amenities in Quincy, IL and picture yourself living here near Quincy University.",
  "property_seo_title_virtualtours": "Affordable Apartments Near Quincy University | Virtual Tour",
  "property_seo_description_virtualtours": "Take a virtual tour of our Quincy apartments and explore our community from the comfort of your own device & experience apartment living near Quincy University.",
  "property_seo_title_interactivemap": "Apartments Near Quincy Mall | Interactive Leasing",
  "property_seo_description_interactivemap": "Start your apartment search online with interactive leasing tools. Make your apartment hunting journey in Quincy, IL at  at Cedar Creek Crossing easier!",
  "property_seo_title_neighborhood": "Affordable Apts Near Downtown Quincy, IL | Neighborhood",
  "property_seo_description_neighborhood": "Cedar Creek Crossing apartment lviing put you lose to Downtown Quincy, Quincy University, John Wood Community College, Blessing Health System, and Quincy Mall.",
  "property_seo_title_contact": "Apartments in Quincy, IL | Cedar Creek Crossing | Contact",
  "property_seo_description_contact": "Contact us today at Cedar Creek Crossing Apartments in Quincy, IL to learn about availability, pricing, and leasing.",
  "property_seo_title_faqs": "FAQs | Apartments in Quincy, IL",
  "property_seo_description_faqs": "Uncover the answers you seek at Cedar Creek Crossing in Quincy, IL. Our FAQs page covers everything from two and three-bedroom floor plans to amenities.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Quincy, IL",
  "property_seo_description_reviews": "Uncover why residents love Cedar Creek Crossing! Read reviews on our spacious two and three-bedroom homes and enjoy top-notch amenities in Quincy, IL.",
  "property_seo_title_applynow": "2- and 3-Bedroom Apartments in North Quincy, IL | Apply Now",
  "property_seo_description_applynow": "Apply online for a 2- or 3-bedroom apartment for rent in Quincy, IL at Cedar Creek Crossing and experience one of the best apartment living options in Quincy.",
  "property_seo_title_residentaccess": "Apartments for Rent in North Quincy | Resident Access",
  "property_seo_description_residentaccess": "Access the resident portal at Cedar Creek Crossing Apartments to pay rent, submit maintenance requests, and manage your account online.",
  "property_seo_title_referafriend": "Refer A Friend | Cedar Creek Crossing",
  "property_seo_description_referafriend": "Refer a friend to Cedar Creek Crossing in Quincy, IL! Share the joy of vibrant living and great neighbors. Create your ideal community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Affordable Quincy, IL Apartments for Rent",
  "property_seo_description_scheduletour": "Schedule a tour of our Quincy apartments for rent & experience Cedar Creek Crossing in person to experience one of the best apartment living options in Quincy.",
  "property_seo_title_privacy": "Privacy Policy | Cedar Creek Crossing",
  "property_seo_description_privacy": "Protecting your privacy is our priority at Cedar Creek Crossing. Read our policy to learn how we safeguard your information in Quincy, IL.",
  "property_seo_title_accessibility": "Website Accessibility | Cedar Creek Crossing",
  "property_seo_description_accessibility": "At Cedar Creek Crossing in Quincy, IL, we prioritize digital inclusion. Join our community where accessibility meets comfort and convenience for all residents.",
  "property_seo_title_sitemap": "Sitemap | Cedar Creek Crossing",
  "property_seo_description_sitemap": "Navigate Cedar Creek Crossing in Quincy, IL! Find your ideal apartment and delightful amenities. Check out our sitemap for an easy path to your new home!",
  "property_seo_title_thankyou": "Apartments in North Quincy, Illinois | Thank You",
  "property_seo_description_thankyou": "Thank you for contacting Cedar Creek Crossing Apartments. Our team will be in touch soon to help you find your new home in Quincy, Illinois.",
  "property_seo_title_pets": "Affordable Pet-Friendly Apartments in Quincy, IL | Pets",
  "property_seo_description_pets": "Learn about our pet policy and discover pet-friendly apartments in Quincy, IL at Cedar Creek Crossing.",
  "property_updated_at": "1790113565485",
  "amenities": [
    {
      "id": "custom_c69aed9b-cfcb-4489-8735-5f79aed59c70",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "external_id": "false",
      "title": "Off Street Parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fe2bf8e2-c316-4be8-bac3-83f3c870f749",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4bd94f90-9871-48a7-8ee8-64836dc944a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "external_id": "false",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_077c496a-024b-497d-bfe4-3659c0144ad1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour Laundry Facilities",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6dc9034d-c96e-4d05-a166-b9343795635a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "external_id": "false",
      "title": "Central Air Conditioning",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2f8d22d9-e7b1-4359-b635-83c81e7e5ca3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "external_id": "false",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fbacbefe-1b81-4726-b5dc-1b12806c736a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "external_id": "false",
      "title": "Carpeting",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5ef39510-5511-4830-b35c-31a962adb7d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_606955e1-98a1-425b-9c09-078084e67434",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "external_id": "false",
      "title": "Stove/Oven",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_96a8a83a-155e-49d6-b4bb-b4643edda933",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_43f659cc-7710-4485-8164-ea22af734514",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "external_id": "false",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_854e360e-2cab-427a-bb29-59d423fde514",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "external_id": "false",
      "title": "Washer/Dryer Hookup",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b58a51ca-9a65-4234-9e04-4d2c2c6a85e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "external_id": "false",
      "title": "Heating",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_663282af-5cb1-4300-b1c5-a4c83695b988",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_33995f30-e9e6-4231-ba15-184b2b870de6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "external_id": "false",
      "title": "High Speed Internet Access*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_31827a3c-1c74-4393-98c9-f3b13775e54c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "external_id": "false",
      "title": "Wheelchair Accessible (Rooms)",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0ec2e1e1-a6d4-43ca-ba39-e91e9c32e951",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cac7d138-661b-4afc-9de8-165f5f8e271f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "external_id": "false",
      "title": "Disposal",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_84ed6f9b-94a0-458f-b85b-41d39f424a11",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "external_id": "false",
      "title": "Kitchen",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_405bf713-5f0e-4987-9561-760001e3bffa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_df65ef21-1e14-4fd9-ac10-017982527192",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "external_id": "false",
      "title": "Oven",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f4073ea3-0325-40d9-9cd0-b167d763698d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "external_id": "false",
      "title": "Range",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_036b56c8-ec0d-4fcf-9d20-b6e6407eacbe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "external_id": "false",
      "title": "Views",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f8afc69f-ded9-45e9-9073-0e6ac9acd09a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "external_id": "false",
      "title": "Walk‑In Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3156bbac-0b81-404e-9857-dad0cedaa80c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "external_id": "false",
      "title": "Linen Closet",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dba2e4a1-2698-448f-9dc4-74172d488d09",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "external_id": "false",
      "title": "Balcony/Patio",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_f5eafc2c-96a0-4c16-a624-46edd411e04b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019f439e-d140-726e-88b6-63984666b6bf.webp",
      "image_media": {
        "alt_text": "Modern community lounge area with sofas, coffee tables, and a kitchen counter with bar stools at Cedar Creek Crossing Apartments in Quincy, IL.",
        "public_id": "019f439e-d140-726e-88b6-63984666b6bf",
        "storage_key": "property/6767906449167514/019f439e-d140-726e-88b6-63984666b6bf.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring comfortable seating, a convenient kitchen area, and a welcoming atmosphere for residents.",
      "link": "",
      "alt_text": "Modern community lounge area with sofas, coffee tables, and a kitchen counter with bar stools at Cedar Creek Crossing Apartments in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_66f4221b-2d8d-4de8-8aeb-8caa8e3e361f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019f439e-c8a6-7256-87e7-584aaa67886c.webp",
      "image_media": {
        "alt_text": "Gym with weight machines, medicine balls, and an inversion table at Cedar Creek Crossing Apartments, offering apartments in Quincy, IL.",
        "public_id": "019f439e-c8a6-7256-87e7-584aaa67886c",
        "storage_key": "property/6767906449167514/019f439e-c8a6-7256-87e7-584aaa67886c.webp",
        "width": 2142,
        "height": 2856
      },
      "title": "Community",
      "description": "Our on-site fitness center is equipped with a variety of machines and weights to help you stay active and healthy.",
      "link": "",
      "alt_text": "Gym with weight machines, medicine balls, and an inversion table at Cedar Creek Crossing Apartments, offering apartments in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e449d623-39e1-4c01-bb62-7c61d0153940",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019f439e-c5a0-778e-a95b-ee6e3e50901c.webp",
      "image_media": {
        "alt_text": "Gym equipment including an inversion table, treadmill, weight rack with medicine balls, and yoga balls at Cedar Creek Crossing Apartments, offering apartments in Quincy, IL.",
        "public_id": "019f439e-c5a0-778e-a95b-ee6e3e50901c",
        "storage_key": "property/6767906449167514/019f439e-c5a0-778e-a95b-ee6e3e50901c.webp",
        "width": 2142,
        "height": 2856
      },
      "title": "Community",
      "description": "Stay active and healthy in our on-site fitness center, equipped with cardio machines, free weights, and flexibility equipment for a complete workout.",
      "link": "",
      "alt_text": "Gym equipment including an inversion table, treadmill, weight rack with medicine balls, and yoga balls at Cedar Creek Crossing Apartments, offering apartments in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ea015c31-324a-4d37-aa7d-1edf9d41243d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019f439e-c5fd-7387-85dc-4aabe8177adf.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and bar seating at Cedar Creek Crossing Apartments, offering apartments in Quincy, IL.",
        "public_id": "019f439e-c5fd-7387-85dc-4aabe8177adf",
        "storage_key": "property/6767906449167514/019f439e-c5fd-7387-85dc-4aabe8177adf.webp",
        "width": 2856,
        "height": 2142
      },
      "title": "Apartment",
      "description": "The living room is decorated with a fireplace and comfortable seating, adjacent to a kitchen island with bar stools.",
      "link": "",
      "alt_text": "Living room with fireplace and bar seating at Cedar Creek Crossing Apartments, offering apartments in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5dc9ecf2-f1a8-4522-befb-4d1f32cbd7da",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019f439e-c5fc-71ba-b9e4-f5bc971a63e2.webp",
      "image_media": {
        "alt_text": "Laundry room with multiple washing machines and dryers, and a folding table at Cedar Creek Crossing Apartments, offering apartments in Quincy, IL.",
        "public_id": "019f439e-c5fc-71ba-b9e4-f5bc971a63e2",
        "storage_key": "property/6767906449167514/019f439e-c5fc-71ba-b9e4-f5bc971a63e2.webp",
        "width": 2856,
        "height": 2142
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities equipped with multiple washers and dryers, plus a folding table for your convenience.",
      "link": "",
      "alt_text": "Laundry room with multiple washing machines and dryers, and a folding table at Cedar Creek Crossing Apartments, offering apartments in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c6e16665-b169-48d5-b290-8e237243414b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-e280-77de-b54b-550802c6239b.webp",
      "image_media": {
        "alt_text": "Bedroom with window, doorway to bathroom and kitchen at Cedar Creek Crossing Apartments, offering apartments in Quincy, IL.",
        "public_id": "019e8ef7-e280-77de-b54b-550802c6239b",
        "storage_key": "property/6767906449167514/019e8ef7-e280-77de-b54b-550802c6239b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this comfortable bedroom, featuring a large window for natural light. An adjacent bathroom and kitchen area offer convenience and functionality.",
      "link": "",
      "alt_text": "Bedroom with window, doorway to bathroom and kitchen at Cedar Creek Crossing Apartments, offering apartments in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_95d298a0-c9c7-465b-a79e-7437eb3583b1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-d859-746c-a630-3728ba1bb87c.webp",
      "image_media": {
        "alt_text": "Fitness center with a treadmill, elliptical, and weight machine at Cedar Creek Crossing Apartments, offering apartments in Quincy, IL.",
        "public_id": "019e8ef7-d859-746c-a630-3728ba1bb87c",
        "storage_key": "property/6767906449167514/019e8ef7-d859-746c-a630-3728ba1bb87c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our community fitness center, equipped with a treadmill, elliptical, and weight machine for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with a treadmill, elliptical, and weight machine at Cedar Creek Crossing Apartments, offering apartments in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a68e3e5d-98d0-4e7a-86bb-247da10dd9b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019f054a-1ced-71ea-bf29-8afec2b182ec.webp",
      "image_media": {
        "alt_text": "Couple looking at a smartphone together.",
        "public_id": "019f054a-1ced-71ea-bf29-8afec2b182ec",
        "storage_key": "property/6767906449167514/019f054a-1ced-71ea-bf29-8afec2b182ec.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "A couple uses a smartphone together at a table, likely managing finances or planning their next steps.",
      "link": "",
      "alt_text": "Couple looking at a smartphone together.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_429e867c-ea67-4868-814c-0c72836a3b08",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-dd07-7683-a199-fa0b8540cf87.webp",
      "image_media": {
        "alt_text": "Exterior of a multi-story apartment building with a parking lot in the foreground at Cedar Creek Crossing Apartments, offering apartments in Quincy, IL.",
        "public_id": "019e8ef7-dd07-7683-a199-fa0b8540cf87",
        "storage_key": "property/6767906449167514/019e8ef7-dd07-7683-a199-fa0b8540cf87.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "View of the exterior of a multi-story apartment building, showcasing its architecture and surrounding parking area under a clear blue sky with scattered clouds.",
      "link": "",
      "alt_text": "Exterior of a multi-story apartment building with a parking lot in the foreground at Cedar Creek Crossing Apartments, offering apartments in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9d97e298-01a1-49b6-b991-82e7491dfe28",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-c40f-7339-978c-bba6053ecca0.webp",
      "image_media": {
        "alt_text": "Bedroom with a view into the bathroom and a walk-in closet at Cedar Creek Crossing Apartments, offering apartments in Quincy, IL.",
        "public_id": "019e8ef7-c40f-7339-978c-bba6053ecca0",
        "storage_key": "property/6767906449167514/019e8ef7-c40f-7339-978c-bba6053ecca0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring plush carpeting, a ceiling fan, access to a walk-in closet, and a private entrance to the bathroom.",
      "link": "",
      "alt_text": "Bedroom with a view into the bathroom and a walk-in closet at Cedar Creek Crossing Apartments, offering apartments in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_14e029b8-b1f2-4f24-9555-9b72243a831a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-c2da-7703-969c-e382b164463d.webp",
      "image_media": {
        "alt_text": "Bathroom with an open closet, toilet, bathtub, and vanity with sink at Cedar Creek Crossing Apartments, offering apartments in Quincy, IL.",
        "public_id": "019e8ef7-c2da-7703-969c-e382b164463d",
        "storage_key": "property/6767906449167514/019e8ef7-c2da-7703-969c-e382b164463d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this spacious bathroom featuring a walk-in closet, a full-size bathtub and shower combo, and a vanity with ample counter space and storage.",
      "link": "",
      "alt_text": "Bathroom with an open closet, toilet, bathtub, and vanity with sink at Cedar Creek Crossing Apartments, offering apartments in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_19c0c5f2-b44d-44dd-86fc-86e264bc0d8c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-b528-71d4-b8c9-a73a9b4c697d.webp",
      "image_media": {
        "alt_text": "Bedroom with doors to bathroom and closet at Cedar Creek Crossing Apartments, offering apartments in Quincy, IL.",
        "public_id": "019e8ef7-b528-71d4-b8c9-a73a9b4c697d",
        "storage_key": "property/6767906449167514/019e8ef7-b528-71d4-b8c9-a73a9b4c697d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "View of a bedroom with carpet, showing entryways to a bathroom with a toilet and towels, and a closet with hanging rods.",
      "link": "",
      "alt_text": "Bedroom with doors to bathroom and closet at Cedar Creek Crossing Apartments, offering apartments in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7efd0e1e-944e-4189-80b3-6a9b39ae8bea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-bee2-7219-a6a6-0d5a822aa4a0.webp",
      "image_media": {
        "alt_text": "Bathroom with a bathtub, toilet, and vanity with a sink and mirror at Cedar Creek Crossing Apartments, offering apartments in Quincy, IL.",
        "public_id": "019e8ef7-bee2-7219-a6a6-0d5a822aa4a0",
        "storage_key": "property/6767906449167514/019e8ef7-bee2-7219-a6a6-0d5a822aa4a0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a bathtub and shower combo, a toilet, and a vanity with a sink and mirror, perfect for everyday use.",
      "link": "",
      "alt_text": "Bathroom with a bathtub, toilet, and vanity with a sink and mirror at Cedar Creek Crossing Apartments, offering apartments in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_86041d90-9be7-4c79-832a-3d7fc37a6839",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-b01b-732e-aba6-ce2737691799.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with a doorway leading to a closet and another room at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
        "public_id": "019e8ef7-b01b-732e-aba6-ce2737691799",
        "storage_key": "property/6767906449167514/019e8ef7-b01b-732e-aba6-ce2737691799.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area connected to a functional kitchen with ample counter space and cabinetry.",
      "link": "",
      "alt_text": "Living room and kitchen area with a doorway leading to a closet and another room at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f8ab6814-3418-4420-bcc3-64db9a2b578a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-c437-71b8-abd5-29292e4a6708.webp",
      "image_media": {
        "alt_text": "Kitchen island with double sink and faucet, overlooking living room and bedroom at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
        "public_id": "019e8ef7-c437-71b8-abd5-29292e4a6708",
        "storage_key": "property/6767906449167514/019e8ef7-c437-71b8-abd5-29292e4a6708.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "View of a spacious living area and kitchen, featuring a double sink island, ample natural light, and interior doors.",
      "link": "",
      "alt_text": "Kitchen island with double sink and faucet, overlooking living room and bedroom at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_983f28da-cafc-4b07-8cb9-ac4314df741b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-b134-721a-8615-8bbe2596c950.webp",
      "image_media": {
        "alt_text": "Interior view of two closets, one with shelves and one with a hanging rod and a basket at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
        "public_id": "019e8ef7-b134-721a-8615-8bbe2596c950",
        "storage_key": "property/6767906449167514/019e8ef7-b134-721a-8615-8bbe2596c950.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Ample storage space in these closets, featuring shelving and a hanging rod for organization.",
      "link": "",
      "alt_text": "Interior view of two closets, one with shelves and one with a hanging rod and a basket at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0db8a3ab-69b1-4460-bf36-a1f3b04a1dab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-a1f3-7753-9672-69f1de79046b.webp",
      "image_media": {
        "alt_text": "Empty room with beige carpet and two windows with blinds at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
        "public_id": "019e8ef7-a1f3-7753-9672-69f1de79046b",
        "storage_key": "property/6767906449167514/019e8ef7-a1f3-7753-9672-69f1de79046b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This is an empty room with beige carpet and two windows that let in plenty of natural light. Perfect for a bedroom or office.",
      "link": "",
      "alt_text": "Empty room with beige carpet and two windows with blinds at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b0b4d9b5-0335-4448-9f21-d96c3e4768cb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-9902-7330-8160-d86e1903ce9f.webp",
      "image_media": {
        "alt_text": "Kitchen with double sink and faucet, overlooking a living area with a window at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
        "public_id": "019e8ef7-9902-7330-8160-d86e1903ce9f",
        "storage_key": "property/6767906449167514/019e8ef7-9902-7330-8160-d86e1903ce9f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring a double sink and faucet, seamlessly opening into a bright living space with a large window.",
      "link": "",
      "alt_text": "Kitchen with double sink and faucet, overlooking a living area with a window at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8a829b8d-f011-4821-9aa8-c87ef11ffd8c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-941f-7480-96b4-9288eacac63b.webp",
      "image_media": {
        "alt_text": "Bedroom with closet and doors at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
        "public_id": "019e8ef7-941f-7480-96b4-9288eacac63b",
        "storage_key": "property/6767906449167514/019e8ef7-941f-7480-96b4-9288eacac63b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a closet and convenient access to other areas of the apartment.",
      "link": "",
      "alt_text": "Bedroom with closet and doors at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_723e2da9-37cc-4cb6-bbce-21ad4b0cf719",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-8cd4-741f-8813-cecadc9d3c49.webp",
      "image_media": {
        "alt_text": "Bedroom with carpeted floor, closed blinds on window, and open doorway leading to another room at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
        "public_id": "019e8ef7-8cd4-741f-8813-cecadc9d3c49",
        "storage_key": "property/6767906449167514/019e8ef7-8cd4-741f-8813-cecadc9d3c49.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring plush carpeting and ample natural light from the window. An adjacent room is visible through the open doorway.",
      "link": "",
      "alt_text": "Bedroom with carpeted floor, closed blinds on window, and open doorway leading to another room at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f82d56e2-5ce1-464a-bcab-8aaa3671960e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-8cd0-750b-adbc-f4c0ba07c849.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with a ceiling fan and doors leading to other rooms at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
        "public_id": "019e8ef7-8cd0-750b-adbc-f4c0ba07c849",
        "storage_key": "property/6767906449167514/019e8ef7-8cd0-750b-adbc-f4c0ba07c849.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room and kitchen area, featuring a ceiling fan and easy access to other parts of the apartment.",
      "link": "",
      "alt_text": "Living room and kitchen area with a ceiling fan and doors leading to other rooms at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3fff0789-28b2-43b4-9189-6d7301909be8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-8655-779b-bf7b-f3c61dd54892.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, a white refrigerator, and a white stove at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
        "public_id": "019e8ef7-8655-779b-bf7b-f3c61dd54892",
        "storage_key": "property/6767906449167514/019e8ef7-8655-779b-bf7b-f3c61dd54892.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and functional kitchen featuring white appliances, ample cabinet space, and a double sink.",
      "link": "",
      "alt_text": "Kitchen with white cabinets, a white refrigerator, and a white stove at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_46d70b21-a440-468e-8b6b-054c7cae9583",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-830c-764d-a1fe-9282bfd49740.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with ceiling fan at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
        "public_id": "019e8ef7-830c-764d-a1fe-9282bfd49740",
        "storage_key": "property/6767906449167514/019e8ef7-830c-764d-a1fe-9282bfd49740.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area and open-concept kitchen featuring a breakfast bar, perfect for entertaining. Includes a ceiling fan for comfort.",
      "link": "",
      "alt_text": "Living room and kitchen area with ceiling fan at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0dae0063-fbc3-4b58-a216-c4d3bfcc506a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-80a8-73c8-80c4-9dd2c9172c39.webp",
      "image_media": {
        "alt_text": "Exterior view of a tan apartment building with stone accents, balconies, and a parking lot in the foreground at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
        "public_id": "019e8ef7-80a8-73c8-80c4-9dd2c9172c39",
        "storage_key": "property/6767906449167514/019e8ef7-80a8-73c8-80c4-9dd2c9172c39.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover comfortable living in this exterior view of the apartment community, showcasing its tan siding, stone accents, and private balconies.",
      "link": "",
      "alt_text": "Exterior view of a tan apartment building with stone accents, balconies, and a parking lot in the foreground at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_eaf9dfae-9476-4485-a5b1-53b0aa937502",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-8082-77ae-8a92-7b5b24e259d0.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, refrigerator, stove, and counter space at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
        "public_id": "019e8ef7-8082-77ae-8a92-7b5b24e259d0",
        "storage_key": "property/6767906449167514/019e8ef7-8082-77ae-8a92-7b5b24e259d0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and functional kitchen featuring ample cabinet storage, a refrigerator, and a stove, perfect for preparing meals.",
      "link": "",
      "alt_text": "Kitchen with white cabinets, refrigerator, stove, and counter space at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c0bcf999-91cb-4ca9-8c69-d823da8f2e9a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-7f36-763b-a8f5-bb41c4a2a3be.webp",
      "image_media": {
        "alt_text": "Exterior of a beige apartment building with stone accents and balconies at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
        "public_id": "019e8ef7-7f36-763b-a8f5-bb41c4a2a3be",
        "storage_key": "property/6767906449167514/019e8ef7-7f36-763b-a8f5-bb41c4a2a3be.webp",
        "width": 2090,
        "height": 1269
      },
      "title": "Community",
      "description": "Charming exterior view of the apartment building showcasing its modern design with stone accents and private balconies, surrounded by lush greenery.",
      "link": "",
      "alt_text": "Exterior of a beige apartment building with stone accents and balconies at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2b09591d-5014-4b06-9672-7c34d92d8091",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-7c14-713b-b39b-398984de36ff.webp",
      "image_media": {
        "alt_text": "Exterior of a multi-story apartment building with balconies and stone accents, surrounded by trees and a white fence at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
        "public_id": "019e8ef7-7c14-713b-b39b-398984de36ff",
        "storage_key": "property/6767906449167514/019e8ef7-7c14-713b-b39b-398984de36ff.webp",
        "width": 1928,
        "height": 1248
      },
      "title": "Community",
      "description": "View the exterior of our apartment building, showcasing its modern design and integration with the surrounding natural environment. Enjoy comfortable living in a beautiful setting.",
      "link": "",
      "alt_text": "Exterior of a multi-story apartment building with balconies and stone accents, surrounded by trees and a white fence at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9deb62ef-43f5-437f-bff6-aea6073011c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019f054a-08c1-7227-bcf6-7c6d830afa13.webp",
      "image_media": {
        "alt_text": "Couple enjoying a meal together at a kitchen table.",
        "public_id": "019f054a-08c1-7227-bcf6-7c6d830afa13",
        "storage_key": "property/6767906449167514/019f054a-08c1-7227-bcf6-7c6d830afa13.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "A smiling couple shares a meal at their kitchen table, highlighting the comfortable and inviting atmosphere of apartment living.",
      "link": "",
      "alt_text": "Couple enjoying a meal together at a kitchen table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fab81963-1b9a-4116-ac61-bfc51169a741",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-79e1-75ae-99c2-0eaae2b74ed4.webp",
      "image_media": {
        "alt_text": "Clubhouse area with sofa, chairs, and small kitchen counter at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
        "public_id": "019e8ef7-79e1-75ae-99c2-0eaae2b74ed4",
        "storage_key": "property/6767906449167514/019e8ef7-79e1-75ae-99c2-0eaae2b74ed4.webp",
        "width": 2098,
        "height": 1406
      },
      "title": "Community",
      "description": "Relax in the comfortable living area, perfect for gathering with friends or enjoying a quiet moment. Includes a small kitchen counter for convenience.",
      "link": "",
      "alt_text": "Clubhouse area with sofa, chairs, and small kitchen counter at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0d1ed04c-1c29-426c-ad10-477de1dbdbee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-6c6b-7547-a0cd-2159aaafb222.webp",
      "image_media": {
        "alt_text": "Exterior view of a multifamily apartment building with balconies, windows, and trees at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
        "public_id": "019e8ef7-6c6b-7547-a0cd-2159aaafb222",
        "storage_key": "property/6767906449167514/019e8ef7-6c6b-7547-a0cd-2159aaafb222.webp",
        "width": 2019,
        "height": 1278
      },
      "title": "Community",
      "description": "A multi-story apartment building featuring light-colored siding, stone accents, and private balconies. Landscaped grounds with trees surround the building.",
      "link": "",
      "alt_text": "Exterior view of a multifamily apartment building with balconies, windows, and trees at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a2fd1846-04e3-45d3-84c4-e078bf546a47",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-6cf0-7332-9a25-b70e1ea1b6d4.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and apartment buildings at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
        "public_id": "019e8ef7-6cf0-7332-9a25-b70e1ea1b6d4",
        "storage_key": "property/6767906449167514/019e8ef7-6cf0-7332-9a25-b70e1ea1b6d4.webp",
        "width": 2250,
        "height": 1500
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling blue swimming pool, surrounded by the beautifully maintained community grounds and apartment buildings.",
      "link": "",
      "alt_text": "Outdoor swimming pool and apartment buildings at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6f7e59e9-f750-420b-9d00-8622dfd9c8b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-6cce-75de-94fd-5b4189f1983a.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with sofa, dining table, and breakfast bar at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
        "public_id": "019e8ef7-6cce-75de-94fd-5b4189f1983a",
        "storage_key": "property/6767906449167514/019e8ef7-6cce-75de-94fd-5b4189f1983a.webp",
        "width": 2250,
        "height": 1500
      },
      "title": "Apartment",
      "description": "Spacious living and dining area seamlessly connected to a modern kitchen, perfect for entertaining.",
      "link": "",
      "alt_text": "Living room and kitchen area with sofa, dining table, and breakfast bar at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_70d78c5c-8440-4ffa-b66b-1e5444305824",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-6ccc-744e-aac1-f41c1cd240ef.webp",
      "image_media": {
        "alt_text": "Bedroom with queen-size bed, two windows, and abstract art at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
        "public_id": "019e8ef7-6ccc-744e-aac1-f41c1cd240ef",
        "storage_key": "property/6767906449167514/019e8ef7-6ccc-744e-aac1-f41c1cd240ef.webp",
        "width": 2250,
        "height": 1500
      },
      "title": "Apartment",
      "description": "A spacious bedroom featuring a comfortable queen-size bed, two large windows that let in plenty of natural light, and modern abstract art on the walls.",
      "link": "",
      "alt_text": "Bedroom with queen-size bed, two windows, and abstract art at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_17c2af02-8917-4927-823c-c5348911351b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019f054a-4a9a-74ba-87ca-b878d49dbc14.webp",
      "image_media": {
        "alt_text": "Man with beard and mustache holding a mug in a living room.",
        "public_id": "019f054a-4a9a-74ba-87ca-b878d49dbc14",
        "storage_key": "property/6767906449167514/019f054a-4a9a-74ba-87ca-b878d49dbc14.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "Enjoy a morning coffee in your stylish new apartment. This image captures a relaxed lifestyle within a comfortable living space.",
      "link": "",
      "alt_text": "Man with beard and mustache holding a mug in a living room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_abb4676e-d29e-4516-ae8b-ee6f5c0f8fdd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-6d07-70ec-84ce-f286ce42c52c.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, countertops, refrigerator, microwave, and sink at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
        "public_id": "019e8ef7-6d07-70ec-84ce-f286ce42c52c",
        "storage_key": "property/6767906449167514/019e8ef7-6d07-70ec-84ce-f286ce42c52c.webp",
        "width": 2155,
        "height": 1459
      },
      "title": "Apartment",
      "description": "A clean and functional kitchen featuring white cabinetry, a double sink, a microwave, and a refrigerator. Perfect for preparing meals.",
      "link": "",
      "alt_text": "Kitchen with white cabinets, countertops, refrigerator, microwave, and sink at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_26cd325b-3012-4003-90ec-9aebb42a7f65",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019f054a-26af-7141-bd8a-c6958625cb54.webp",
      "image_media": {
        "alt_text": "Father lifting his laughing child.",
        "public_id": "019f054a-26af-7141-bd8a-c6958625cb54",
        "storage_key": "property/6767906449167514/019f054a-26af-7141-bd8a-c6958625cb54.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Lifestyle",
      "description": "A father happily lifts his laughing child in the air, showcasing a moment of joy and family life within the community.",
      "link": "",
      "alt_text": "Father lifting his laughing child.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_89353c05-094d-4a65-add3-66dcb5b289e9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-6ca9-73ff-af3b-38a36fe5de8f.webp",
      "image_media": {
        "alt_text": "Playground with slides and a fire truck springer, next to an apartment building at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
        "public_id": "019e8ef7-6ca9-73ff-af3b-38a36fe5de8f",
        "storage_key": "property/6767906449167514/019e8ef7-6ca9-73ff-af3b-38a36fe5de8f.webp",
        "width": 1661,
        "height": 1045
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring slides, climbing structures, and a playful fire truck springer. Perfect for families and outdoor recreation.",
      "link": "",
      "alt_text": "Playground with slides and a fire truck springer, next to an apartment building at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_815a1a35-1782-42af-a196-f6f820d8b398",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-6ca9-73ff-af3b-373047288196.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with stone accents and balconies at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
        "public_id": "019e8ef7-6ca9-73ff-af3b-373047288196",
        "storage_key": "property/6767906449167514/019e8ef7-6ca9-73ff-af3b-373047288196.webp",
        "width": 1800,
        "height": 1200
      },
      "title": "Community",
      "description": "Charming apartment building exterior featuring siding, stone details, and private balconies. Lush greenery surrounds the property.",
      "link": "",
      "alt_text": "Exterior view of apartment building with stone accents and balconies at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_416e209e-a89f-45dc-82f1-0f689af03ae5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019f0549-ffc7-72dd-9467-0f8797651ae1.webp",
      "image_media": {
        "alt_text": "A man gently pets a striped tabby cat, looking at it with a warm expression by a sunlit window.",
        "public_id": "019f0549-ffc7-72dd-9467-0f8797651ae1",
        "storage_key": "property/6767906449167514/019f0549-ffc7-72dd-9467-0f8797651ae1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "Experience pet-friendly living at our community! Our residents and their furry companions enjoy a comfortable and welcoming environment. Find your perfect home with us.",
      "link": "",
      "alt_text": "A man gently pets a striped tabby cat, looking at it with a warm expression by a sunlit window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_47bed19f-cc5a-45d9-b1de-70c23cde504b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-6bab-740c-88c2-443548d81586.webp",
      "image_media": {
        "alt_text": "Resort-style outdoor swimming pool with lounge chairs and umbrellas at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
        "public_id": "019e8ef7-6bab-740c-88c2-443548d81586",
        "storage_key": "property/6767906449167514/019e8ef7-6bab-740c-88c2-443548d81586.webp",
        "width": 2189,
        "height": 1454
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded umbrellas for your enjoyment.",
      "link": "",
      "alt_text": "Resort-style outdoor swimming pool with lounge chairs and umbrellas at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a4892d5d-6bfc-403b-913c-a6bd1f2a5488",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-6b4d-777f-a141-451f4ee26f49.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmill, elliptical, and weight machine at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
        "public_id": "019e8ef7-6b4d-777f-a141-451f4ee26f49",
        "storage_key": "property/6767906449167514/019e8ef7-6b4d-777f-a141-451f4ee26f49.webp",
        "width": 2157,
        "height": 1469
      },
      "title": "Community",
      "description": "Stay active and healthy in our well-equipped fitness center, featuring a treadmill, elliptical trainer, and weight machine for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with treadmill, elliptical, and weight machine at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d096396c-4801-4f57-8442-26486bc43d33",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-5ae0-748a-ad0e-b7b4dca3630e.webp",
      "image_media": {
        "alt_text": "Cedar Creek apartment complex exterior with monument sign and landscaping.",
        "public_id": "019e8ef7-5ae0-748a-ad0e-b7b4dca3630e",
        "storage_key": "property/6767906449167514/019e8ef7-5ae0-748a-ad0e-b7b4dca3630e.webp",
        "width": 1744,
        "height": 1163
      },
      "title": "Community",
      "description": "Welcome to Cedar Creek, an apartment community featuring beautiful grounds and a welcoming atmosphere. Enjoy the convenience of our location and the comfort of your home.",
      "link": "",
      "alt_text": "Cedar Creek apartment complex exterior with monument sign and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ee693e04-a244-47ab-aa75-7ca131a49051",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-5684-77df-a4ac-bd1402666a36.webp",
      "image_media": {
        "alt_text": "Living room and bedroom of an apartment.",
        "public_id": "019e8ef7-5684-77df-a4ac-bd1402666a36",
        "storage_key": "property/6767906449167514/019e8ef7-5684-77df-a4ac-bd1402666a36.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious living room with a large sectional sofa and a view into a bedroom.",
      "link": "",
      "alt_text": "Living room and bedroom of an apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cc112a4a-1196-4642-b3fb-13bef148cc9e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-5699-72ad-b123-ecad5274ef9a.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
        "public_id": "019e8ef7-5699-72ad-b123-ecad5274ef9a",
        "storage_key": "property/6767906449167514/019e8ef7-5699-72ad-b123-ecad5274ef9a.webp",
        "width": 2019,
        "height": 1269
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and shaded umbrellas.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_43885cfd-ee11-4c57-ad39-43c438345aad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e8ef7-5612-768b-8e9e-2c40f3b075be.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances, cream cabinets, and a breakfast bar with stools at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
        "public_id": "019e8ef7-5612-768b-8e9e-2c40f3b075be",
        "storage_key": "property/6767906449167514/019e8ef7-5612-768b-8e9e-2c40f3b075be.webp",
        "width": 2016,
        "height": 1461
      },
      "title": "Apartment",
      "description": "A bright and functional kitchen featuring white appliances, ample cabinet space, and a convenient breakfast bar with seating.",
      "link": "",
      "alt_text": "Kitchen with white appliances, cream cabinets, and a breakfast bar with stools at Cedar Creek Crossing Apartments, offering apartments for rent in Quincy, IL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8fe07754-ee9e-41cd-aa18-05693bd5a115",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019f054a-2a47-7327-a85a-682023311c02.webp",
      "image_media": {
        "alt_text": "Woman sitting on a couch and using her smartphone.",
        "public_id": "019f054a-2a47-7327-a85a-682023311c02",
        "storage_key": "property/6767906449167514/019f054a-2a47-7327-a85a-682023311c02.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Lifestyle",
      "description": "A young woman relaxes on a comfortable sofa while browsing on her mobile phone, embodying a modern and connected lifestyle.",
      "link": "",
      "alt_text": "Woman sitting on a couch and using her smartphone.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_204b3888-1886-4508-9b48-b53e9f94f9f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019f054a-61b1-712b-88ce-f22429dcef2c.webp",
      "image_media": {
        "alt_text": "Two people walking a small white dog on a leash in a park.",
        "public_id": "019f054a-61b1-712b-88ce-f22429dcef2c",
        "storage_key": "property/6767906449167514/019f054a-61b1-712b-88ce-f22429dcef2c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "Enjoy the pet-friendly atmosphere and beautiful outdoor spaces with your furry companion.",
      "link": "",
      "alt_text": "Two people walking a small white dog on a leash in a park.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a5a1ac6f-cbfd-4917-9ced-faa044c0f382",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019f054a-184d-746f-bcb0-f46a247ac7d2.webp",
      "image_media": {
        "alt_text": "Two young women laughing while looking at a smartphone.",
        "public_id": "019f054a-184d-746f-bcb0-f46a247ac7d2",
        "storage_key": "property/6767906449167514/019f054a-184d-746f-bcb0-f46a247ac7d2.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Lifestyle",
      "description": "Experience the vibrant lifestyle at our community. Connect with friends and share moments on your phone.",
      "link": "",
      "alt_text": "Two young women laughing while looking at a smartphone.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_14cce1f8-0505-4c0f-960b-ba6b735e375f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "Culver’s",
      "poi_type": "Restaurants",
      "poi_address": "2442 Broadway St, Quincy, IL 62301, USA",
      "poi_short_description": "Fast-food chain specializing in frozen custard & signature burgers made with Midwest beef & dairy.",
      "poi_long_description": "People say this restaurant offers delicious and fresh food, including butter burgers, crispy chicken sandwiches, and cheese curds. They also highlight the friendly and attentive staff, as well as the fast service. Others mention the restaurant is clean and well-maintained, with spotless restrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-e109-779a-99f2-99d8409f6832.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-e109-779a-99f2-99d8409f6832",
        "storage_key": "property/6767906449167514/019e46e3-e109-779a-99f2-99d8409f6832.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.culvers.com/restaurants/quincy-il/?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=2696784193089256014&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "culvers",
      "poi_latitude": "39.93503219999999",
      "poi_longitude": "-91.3759026",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 217-222-7758",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-08f0-71da-8a7d-718d8f5fae8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-08f0-71da-8a7d-718d8f5fae8c",
        "storage_key": "property/6767906449167514/019e46e4-08f0-71da-8a7d-718d8f5fae8c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJt_Yh05z33YcRTjr5eO_mbCU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_6b21d0a2-461a-4693-9c84-bdf37d3103fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "5120 Broadway St, Quincy, IL 62305, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "Diners praise the delicious food, particularly the well-seasoned steaks, and appreciate the generous portions. The friendly staff and lively atmosphere also receive high praise.\n\nSome reviews mention the service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-dc3b-7081-89ec-35fafe1dae79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-dc3b-7081-89ec-35fafe1dae79",
        "storage_key": "property/6767906449167514/019e46e3-dc3b-7081-89ec-35fafe1dae79.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/illinois/quincy?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=4086647005450127832&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "39.934069",
      "poi_longitude": "-91.3343518",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 217-221-4600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-08f0-71da-8a7d-718d8f5fae8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-08f0-71da-8a7d-718d8f5fae8c",
        "storage_key": "property/6767906449167514/019e46e4-08f0-71da-8a7d-718d8f5fae8c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWU0rH1P43YcR2MlEqsyvtjg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_d7b57c6f-5af2-4fe7-bc4f-501f808497ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "3601 Broadway St, Quincy, IL 62305, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers, fries, and sweet tea. They also highlight the fast service, friendly staff, and clean environment.\n\nOther reviews mention the fries can be soggy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-e0aa-706d-aba5-af6ad2b6a85b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-e0aa-706d-aba5-af6ad2b6a85b",
        "storage_key": "property/6767906449167514/019e46e3-e0aa-706d-aba5-af6ad2b6a85b.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/il/quincy/3601-broadway-street",
      "poi_directions_map_url": "https://maps.google.com/?cid=17109756965456639432&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "39.9356278",
      "poi_longitude": "-91.3579468",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 217-866-9992",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-08f0-71da-8a7d-718d8f5fae8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-08f0-71da-8a7d-718d8f5fae8c",
        "storage_key": "property/6767906449167514/019e46e4-08f0-71da-8a7d-718d8f5fae8c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX-8Zsr753YcRyPVOB08Rcu0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_7ec5c60e-50d4-41e5-b243-5a6df7992d51",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "Thyme Square Bakery & Cafe",
      "poi_type": "Restaurants",
      "poi_address": "615 Hampshire St, Quincy, IL 62301, USA",
      "poi_short_description": "Cozy cafe spotlighting locally sourced ingredients in breakfast & lunch fare such as eggs Benedict.",
      "poi_long_description": "Diners like this restaurant's delicious, fresh, and creative food, with many items made in-house and sourced locally. They also highlight the friendly and attentive staff, who provide fast service. Guests mention the comfortable and clean atmosphere, making it a great place to gather.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-dabd-719e-a852-9f47c7f8778b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-dabd-719e-a852-9f47c7f8778b",
        "storage_key": "property/6767906449167514/019e46e3-dabd-719e-a852-9f47c7f8778b.webp",
        "width": 384,
        "height": 512
      },
      "poi_business_url": "http://www.thymesquarecafe.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12014952381417749378&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "thyme-square-bakery--cafe",
      "poi_latitude": "39.933413",
      "poi_longitude": "-91.406138",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 217-224-3515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-08f0-71da-8a7d-718d8f5fae8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-08f0-71da-8a7d-718d8f5fae8c",
        "storage_key": "property/6767906449167514/019e46e4-08f0-71da-8a7d-718d8f5fae8c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLXxZvlX23YcRgnujb4ivvaY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_cef7d510-8cd2-40a2-a2b7-8f84e86d72da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "Chick's On The River",
      "poi_type": "Restaurants",
      "poi_address": "236 N Front St, Quincy, IL 62301, USA",
      "poi_short_description": "Casual eatery offering a variety of fried chicken dishes (including signature “lips”) and burgers, plus a patio overlooking the Mississippi River.",
      "poi_long_description": "Diners like this restaurant's delicious chicken lips, portobello mushroom fries, and homemade-tasting burgers, with many options and generous portions. They also highlight the friendly, attentive staff and welcoming atmosphere.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-dabd-719e-a852-9b241a0d4534.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-dabd-719e-a852-9b241a0d4534",
        "storage_key": "property/6767906449167514/019e46e3-dabd-719e-a852-9b241a0d4534.webp",
        "width": 1000,
        "height": 662
      },
      "poi_business_url": "http://www.chicksontheriver.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2605789614197406733&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chicks-on-the-river",
      "poi_latitude": "39.9343738",
      "poi_longitude": "-91.4147593",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 217-222-5477",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-08f0-71da-8a7d-718d8f5fae8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-08f0-71da-8a7d-718d8f5fae8c",
        "storage_key": "property/6767906449167514/019e46e4-08f0-71da-8a7d-718d8f5fae8c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGUaijPf23YcRDXyjGdmfKSQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_26b51a9c-6a7a-4721-b905-158858c262b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "5432 Broadway St, Quincy, IL 62305, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide variety of products and kitchen faucets. They also highlight the competitive prices, convenient hours, and helpful staff.\n\nOther reviews mention the service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-da74-738f-889d-f848167cc183.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-da74-738f-889d-f848167cc183",
        "storage_key": "property/6767906449167514/019e46e3-da74-738f-889d-f848167cc183.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/Quincy/IL/Quincy/62305/1915?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=1809564910389206280&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "39.9325654",
      "poi_longitude": "-91.3285067",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 217-228-2475",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-090c-72f7-b8ba-8a6b3b47067c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-090c-72f7-b8ba-8a6b3b47067c",
        "storage_key": "property/6767906449167514/019e46e4-090c-72f7-b8ba-8a6b3b47067c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJt3kQTlX43YcRCJ3C0bLdHBk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_03acb3f6-8bc8-40c8-9dc6-22a048171a49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "Menards",
      "poi_type": "Shopping & Retail",
      "poi_address": "936 N 54th St, Quincy, IL 62305, USA",
      "poi_short_description": "Home improvement chain with assorted building materials, tools, gardening supplies & appliances.",
      "poi_long_description": "People say this home improvement store offers a wide selection of supplies, appliances, and even some groceries and dog food. They also highlight the great deals and reasonable prices.\n\nOther reviews mention the service can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-dd68-76ee-b976-99e69a2fb305.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-dd68-76ee-b976-99e69a2fb305",
        "storage_key": "property/6767906449167514/019e46e3-dd68-76ee-b976-99e69a2fb305.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.menards.com/store-details/store.html?store=3262&utm_source=gmb&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=3985228389027523724&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "menards",
      "poi_latitude": "39.9409901",
      "poi_longitude": "-91.3278829",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 217-228-1225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-090c-72f7-b8ba-8a6b3b47067c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-090c-72f7-b8ba-8a6b3b47067c",
        "storage_key": "property/6767906449167514/019e46e4-090c-72f7-b8ba-8a6b3b47067c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJYTJsm1f43YcRjKzJ7BpgTjc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_1c2179d2-ea51-4369-9cb4-15ec81c95eac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "Hy-Vee Grocery Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "1400 Harrison St, Quincy, IL 62301, USA",
      "poi_short_description": "Chain grocer and hot-food purveyor, offering groceries, hot food, pizza and baked goods, along with a grill, sushi bar, pharmacy, florist and fuel perks.",
      "poi_long_description": "People say this grocery store offers a wide selection of items and a variety of foods. They highlight the reasonable prices, good sales, and fuel saver rewards system. They also like the clean, well-maintained store and the friendly, helpful staff. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-deaa-738f-af98-ffb1d088620f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-deaa-738f-af98-ffb1d088620f",
        "storage_key": "property/6767906449167514/019e46e3-deaa-738f-af98-ffb1d088620f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hy-vee.com/stores/detail.aspx?s=138&utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=12892948581650368565&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hy-vee-grocery-store",
      "poi_latitude": "39.9133836",
      "poi_longitude": "-91.3951825",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 217-224-9442",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-092e-72bd-b906-a5e6c5d9f71c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-092e-72bd-b906-a5e6c5d9f71c",
        "storage_key": "property/6767906449167514/019e46e4-092e-72bd-b906-a5e6c5d9f71c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfytFphf33YcRNYil3Gz07LI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_01f4e1d2-fd81-4b93-ac4b-89e568e836b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "6030 Broadway St, Quincy, IL 62305, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-da7f-72ed-a16f-cc735aadbe79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-da7f-72ed-a16f-cc735aadbe79",
        "storage_key": "property/6767906449167514/019e46e3-da7f-72ed-a16f-cc735aadbe79.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/IL-Quincy/1680?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1680-_-na-_-0-_-0&y_source=1_MTE4Mjg3NC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=13077490381053917680&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "39.934397",
      "poi_longitude": "-91.3205",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 217-228-4250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-090c-72f7-b8ba-8a6b3b47067c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-090c-72f7-b8ba-8a6b3b47067c",
        "storage_key": "property/6767906449167514/019e46e4-090c-72f7-b8ba-8a6b3b47067c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJjdR0I_343YcR8HlOzDaUfLU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_30d97e6e-7799-46c9-9b87-e0b0383ecac1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "Quincy University",
      "poi_type": "Education",
      "poi_address": "1800 College Ave, Quincy, IL 62301, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-e3bd-74a5-abbc-b923171bd38c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-e3bd-74a5-abbc-b923171bd38c",
        "storage_key": "property/6767906449167514/019e46e3-e3bd-74a5-abbc-b923171bd38c.webp",
        "width": 1280,
        "height": 848
      },
      "poi_business_url": "https://www.quincy.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16995110785298673421&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "quincy-university",
      "poi_latitude": "39.9405844",
      "poi_longitude": "-91.3854387",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 217-222-8020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-08f1-737a-87c7-2865915aa8d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-08f1-737a-87c7-2865915aa8d1",
        "storage_key": "property/6767906449167514/019e46e4-08f1-737a-87c7-2865915aa8d1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHYQ7K7z33YcRDS8jHDfD2us",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_9fa9107f-afe1-46a9-bcad-76f999a83bc7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "John Wood Community College",
      "poi_type": "Education",
      "poi_address": "1301 S 48th St, Quincy, IL 62305, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-e7ad-7202-9b18-be218d730f28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-e7ad-7202-9b18-be218d730f28",
        "storage_key": "property/6767906449167514/019e46e3-e7ad-7202-9b18-be218d730f28.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.jwcc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10066911618274044595&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "john-wood-community-college",
      "poi_latitude": "39.913793",
      "poi_longitude": "-91.3364",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 217-224-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-08f1-737a-87c7-2865915aa8d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-08f1-737a-87c7-2865915aa8d1",
        "storage_key": "property/6767906449167514/019e46e4-08f1-737a-87c7-2865915aa8d1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJczB30qL53YcRsyp6sMfatIs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_8999e58c-c236-4371-b820-6324c4b7db6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "Quincy Public Library",
      "poi_type": "Education",
      "poi_address": "526 Jersey St, Quincy, IL 62301, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-e605-7676-95ab-17cc3ee32411.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-e605-7676-95ab-17cc3ee32411",
        "storage_key": "property/6767906449167514/019e46e3-e605-7676-95ab-17cc3ee32411.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://quincylibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5729775028874868128&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "quincy-public-library",
      "poi_latitude": "39.9297724",
      "poi_longitude": "-91.407279",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 217-223-1309",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-0925-740c-98cb-6c0155c9558a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-0925-740c-98cb-6c0155c9558a",
        "storage_key": "property/6767906449167514/019e46e4-0925-740c-98cb-6c0155c9558a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1xz9Cf_23YcRoHX99gdAhE8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_0345282d-0151-481b-8d38-d1f8cd426208",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "JWCC Workforce Development Center",
      "poi_type": "Education",
      "poi_address": "2710 N 42nd St, Quincy, IL 62305, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-e355-76b8-9229-b9d2a0a76d3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-e355-76b8-9229-b9d2a0a76d3c",
        "storage_key": "property/6767906449167514/019e46e3-e355-76b8-9229-b9d2a0a76d3c.webp",
        "width": 1024,
        "height": 682
      },
      "poi_business_url": "https://www.jwcc.edu/wdc",
      "poi_directions_map_url": "https://maps.google.com/?cid=11337930155527244278&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jwcc-workforce-development-center",
      "poi_latitude": "39.9639621",
      "poi_longitude": "-91.3469785",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 217-641-4971",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-08f1-737a-87c7-2865915aa8d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-08f1-737a-87c7-2865915aa8d1",
        "storage_key": "property/6767906449167514/019e46e4-08f1-737a-87c7-2865915aa8d1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSdKOU2343YcR9glk0GdrWJ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_dc300839-9aaf-46c0-8075-524a33e7a1d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "Flinn Memorial Stadium",
      "poi_type": "Entertainment",
      "poi_address": "4400 Maine St, Quincy, IL 62305, USA",
      "poi_short_description": "Stadium used for high school football, with a playground.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-e62c-707a-a0d6-b49aac16b419.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-e62c-707a-a0d6-b49aac16b419",
        "storage_key": "property/6767906449167514/019e46e3-e62c-707a-a0d6-b49aac16b419.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=776410496887404109&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "flinn-memorial-stadium",
      "poi_latitude": "39.928925",
      "poi_longitude": "-91.3434228",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 217-224-4607",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-0933-76dc-9bc7-bddd60df0398.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-0933-76dc-9bc7-bddd60df0398",
        "storage_key": "property/6767906449167514/019e46e4-0933-76dc-9bc7-bddd60df0398.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCcS3CbX53YcRTbbbujtdxgo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_ca257881-2811-4b66-9acb-a03d49dae10f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "Quincy Children's Museum",
      "poi_type": "Entertainment",
      "poi_address": "115 N 4th St, Quincy, IL 62301, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this children's museum offers many engaging activities and exhibits for kids of various ages, including a gymnastics area and an art room. Visitors also highlight the reasonable prices and the clean, well-maintained play areas. They also mention the friendly and helpful staff, who are great with children.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-ebe8-7474-bb01-a0bf8efb0266.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-ebe8-7474-bb01-a0bf8efb0266",
        "storage_key": "property/6767906449167514/019e46e3-ebe8-7474-bb01-a0bf8efb0266.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.quincychildrensmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12917606187450021359&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "quincy-childrens-museum",
      "poi_latitude": "39.9325345",
      "poi_longitude": "-91.4102043",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 217-440-3388",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-08f1-737a-87c7-2e13739c8211.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-08f1-737a-87c7-2e13739c8211",
        "storage_key": "property/6767906449167514/019e46e4-08f1-737a-87c7-2e13739c8211.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJT3SRjcL33YcR77VYF2OORLM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_ffe556f2-8cac-45ae-8d73-e03326b9739d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "QU Baseball Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1300 N 18th St, Quincy, IL 62301, USA",
      "poi_short_description": "Stadium primarily hosting baseball, with nearby street parking and restrooms.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-e669-722c-b850-d468ffd8f6b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-e669-722c-b850-d468ffd8f6b7",
        "storage_key": "property/6767906449167514/019e46e3-e669-722c-b850-d468ffd8f6b7.webp",
        "width": 1280,
        "height": 962
      },
      "poi_business_url": "http://hawks.quincy.edu/index.aspx?path=baseball",
      "poi_directions_map_url": "https://maps.google.com/?cid=18425494866792892315&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "qu-baseball-stadium",
      "poi_latitude": "39.9474178",
      "poi_longitude": "-91.3861159",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 217-222-8020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-0933-76dc-9bc7-bddd60df0398.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-0933-76dc-9bc7-bddd60df0398",
        "storage_key": "property/6767906449167514/019e46e4-0933-76dc-9bc7-bddd60df0398.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJyVyx3b333YcRm0f5efWBtP8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_2f48c873-5931-45b1-9f07-e8873788a1ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "The Quincy Museum",
      "poi_type": "Entertainment",
      "poi_address": "1601 Maine St, Quincy, IL 62301, USA",
      "poi_short_description": "Local history museum & prehistoric relics in a restored Richardsonian Romanesque mansion.",
      "poi_long_description": "Local history museum & prehistoric relics in a restored Richardsonian Romanesque mansion.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-e92b-779c-a721-bec07e3b8395.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-e92b-779c-a721-bec07e3b8395",
        "storage_key": "property/6767906449167514/019e46e3-e92b-779c-a721-bec07e3b8395.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://thequincymuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4892182989407021875&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-quincy-museum",
      "poi_latitude": "39.9322698",
      "poi_longitude": "-91.3898283",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 217-224-7669",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-08f1-737a-87c7-2e13739c8211.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-08f1-737a-87c7-2e13739c8211",
        "storage_key": "property/6767906449167514/019e46e4-08f1-737a-87c7-2e13739c8211.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJVTDEr6D33YcRM2vQS4KG5EM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_b394c0aa-54ec-4ce7-bf20-00d7b2ee0e88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "QU Football & Lacrosse Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1301 N 20th St, Quincy, IL 62301, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-e98b-759b-857b-6b3f3d376eec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-e98b-759b-857b-6b3f3d376eec",
        "storage_key": "property/6767906449167514/019e46e3-e98b-759b-857b-6b3f3d376eec.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://hawks.quincy.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1870152795389771402&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "qu-football--lacrosse-stadium",
      "poi_latitude": "39.9473248",
      "poi_longitude": "-91.385058",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 217-222-8020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-0933-76dc-9bc7-bddd60df0398.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-0933-76dc-9bc7-bddd60df0398",
        "storage_key": "property/6767906449167514/019e46e4-0933-76dc-9bc7-bddd60df0398.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDT3hCZb33YcRij7pFA8e9Bk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_480fef3c-7a9d-4202-bbe2-638123a38cbb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "Gold Line Barbershop",
      "poi_type": "Health and Wellness",
      "poi_address": "828 Maine St, Quincy, IL 62301, USA",
      "poi_short_description": "Old-school shop offering haircuts and beard trims in a cool atmosphere.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-ed34-736d-af6d-49eafb58e0f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-ed34-736d-af6d-49eafb58e0f3",
        "storage_key": "property/6767906449167514/019e46e3-ed34-736d-af6d-49eafb58e0f3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15843821035039662523&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gold-line-barbershop",
      "poi_latitude": "39.931667",
      "poi_longitude": "-91.4022723",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 925-234-6087",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-092f-71b9-aa62-31a0364f59b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-092f-71b9-aa62-31a0364f59b2",
        "storage_key": "property/6767906449167514/019e46e4-092f-71b9-aa62-31a0364f59b2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRXZccQD33YcRu6FmhkmP4Ns",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_6f6a27f9-c0d4-476c-bc71-7dc31179eacd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3007 Broadway St, Quincy, IL 62301, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of exercise machines, tanning beds, and massage chairs. They also highlight the affordable membership, welcoming atmosphere, and helpful staff.\n\nOther reviews mention the tanning bed time can be inaccurate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-ebe8-7474-bb01-a4085ad0e49d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-ebe8-7474-bb01-a4085ad0e49d",
        "storage_key": "property/6767906449167514/019e46e3-ebe8-7474-bb01-a4085ad0e49d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/quincy-il?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=3219886224120325090&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "39.93645480000001",
      "poi_longitude": "-91.3668489",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 217-209-0244",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-092f-71b9-aa62-31a0364f59b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-092f-71b9-aa62-31a0364f59b2",
        "storage_key": "property/6767906449167514/019e46e4-092f-71b9-aa62-31a0364f59b2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUw6lxDD33YcR4qPdDXZVryw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_df28204c-e168-4e4a-a1f5-07cf267bb423",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "Gem City Gymnastics & Tumbling, LLC.",
      "poi_type": "Health and Wellness",
      "poi_address": "2010 Jennifer Ln, Quincy, IL 62301, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers engaging classes that help children learn skills and improve balance and flexibility. They also highlight the knowledgeable and caring coaching staff, who work well with kids of all ages. Guests mention the positive and fun environment, making it a great place for birthday parties.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-ed70-771e-afbe-19383c21d9c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-ed70-771e-afbe-19383c21d9c0",
        "storage_key": "property/6767906449167514/019e46e3-ed70-771e-afbe-19383c21d9c0.webp",
        "width": 808,
        "height": 960
      },
      "poi_business_url": "http://gemcitygymnasticsandtumbling.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11262416466728247208&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gem-city-gymnastics--tumbling-llc",
      "poi_latitude": "39.9549464",
      "poi_longitude": "-91.3832209",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 217-224-8491",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-08f1-737a-87c7-2865915aa8d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-08f1-737a-87c7-2865915aa8d1",
        "storage_key": "property/6767906449167514/019e46e4-08f1-737a-87c7-2865915aa8d1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJD8lAWur33YcRqN_YCxskTJw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_fdc24bab-bbe9-40b1-8a8d-a9b69925a417",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "Western Illinois Veterinary Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "3910 Wisman Ln, Quincy, IL 62305, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-f04b-757b-8222-3051a9e1b820.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-f04b-757b-8222-3051a9e1b820",
        "storage_key": "property/6767906449167514/019e46e3-f04b-757b-8222-3051a9e1b820.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.westernillinoisvetclinic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13630147051061364383&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "western-illinois-veterinary-clinic",
      "poi_latitude": "39.9566014",
      "poi_longitude": "-91.352764",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 217-228-0414",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-092f-71b9-aa62-31a0364f59b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-092f-71b9-aa62-31a0364f59b2",
        "storage_key": "property/6767906449167514/019e46e4-092f-71b9-aa62-31a0364f59b2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ43eWlRb43YcRn8bZ_oYCKL0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_e91997a5-2102-4e8c-a4d5-e7dede191c63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "Four Paws Veterinary Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "2517 W Schneidman Dr, Quincy, IL 62305, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-eff8-765e-82a8-8b00b41b38ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-eff8-765e-82a8-8b00b41b38ad",
        "storage_key": "property/6767906449167514/019e46e3-eff8-765e-82a8-8b00b41b38ad.webp",
        "width": 828,
        "height": 315
      },
      "poi_business_url": "http://www.fourpawsquincy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14858364264700777250&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "four-paws-veterinary-clinic",
      "poi_latitude": "39.9616095",
      "poi_longitude": "-91.385864",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 217-209-3225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-092f-71b9-aa62-31a0364f59b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-092f-71b9-aa62-31a0364f59b2",
        "storage_key": "property/6767906449167514/019e46e4-092f-71b9-aa62-31a0364f59b2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUzKePZ_33YcRIhPZZJODM84",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_c798a735-05d4-438d-86bc-aac245c2083b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "Mayly Nails",
      "poi_type": "Health and Wellness",
      "poi_address": "5315 Oak St, Quincy, IL 62305, USA",
      "poi_short_description": "Stylish nail salon offering manicures, acrylics, gels, hot rock massages and pedicures .",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-f03f-7633-af85-2fb08aa14760.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-f03f-7633-af85-2fb08aa14760",
        "storage_key": "property/6767906449167514/019e46e3-f03f-7633-af85-2fb08aa14760.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://maylynailsquincy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14236319333717108238&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mayly-nails",
      "poi_latitude": "39.9376182",
      "poi_longitude": "-91.330429",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 217-221-8555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-092f-71b9-aa62-31a0364f59b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-092f-71b9-aa62-31a0364f59b2",
        "storage_key": "property/6767906449167514/019e46e4-092f-71b9-aa62-31a0364f59b2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC--ELVT43YcRDuY7uwGRkcU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_d6ae1e1e-11cd-4530-adb8-661910859455",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "Nail It Salon Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "4440 Broadway St Suite 9, Quincy, IL 62305, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-01c8-752f-bd39-aa5b1874ef94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e4-01c8-752f-bd39-aa5b1874ef94",
        "storage_key": "property/6767906449167514/019e46e4-01c8-752f-bd39-aa5b1874ef94.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.nailitsalonspa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3545719059598071039&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "nail-it-salon-spa",
      "poi_latitude": "39.9343102",
      "poi_longitude": "-91.3445826",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 217-228-4067",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-092f-71b9-aa62-31a0364f59b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-092f-71b9-aa62-31a0364f59b2",
        "storage_key": "property/6767906449167514/019e46e4-092f-71b9-aa62-31a0364f59b2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoUR9-Xj53YcR_9Ss3LLsNDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_f91e643e-3bfa-413f-9071-a3be6c5539e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "Great Clips",
      "poi_type": "Health and Wellness",
      "poi_address": "6230 Broadway St, Quincy, IL 62305, USA",
      "poi_short_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_long_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-f244-70e9-9281-3333668f510f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-f244-70e9-9281-3333668f510f",
        "storage_key": "property/6767906449167514/019e46e3-f244-70e9-9281-3333668f510f.webp",
        "width": 680,
        "height": 383
      },
      "poi_business_url": "https://salons.greatclips.com/us/il/quincy/6230-broadway-st?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=15690290053922962&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-clips",
      "poi_latitude": "39.9333738",
      "poi_longitude": "-91.3161875",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 217-223-7366",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-092f-71b9-aa62-31a0364f59b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-092f-71b9-aa62-31a0364f59b2",
        "storage_key": "property/6767906449167514/019e46e4-092f-71b9-aa62-31a0364f59b2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJcKsV-L43YcRkkAWVTy-NwA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_0cbe3d83-de99-4f8f-b3fe-21107b289cb3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "Kustom Cut’s",
      "poi_type": "Health and Wellness",
      "poi_address": "4811 Broadway St, Quincy, IL 62305, USA",
      "poi_short_description": "Salon offering hair-cutting services including kids' haircuts, as well as tanning.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-f61b-76dc-b301-e3290906d92e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-f61b-76dc-b301-e3290906d92e",
        "storage_key": "property/6767906449167514/019e46e3-f61b-76dc-b301-e3290906d92e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1363243714819977516&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kustom-cuts",
      "poi_latitude": "39.9360573",
      "poi_longitude": "-91.3388973",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 217-214-4247",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-092f-71b9-aa62-31a0364f59b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-092f-71b9-aa62-31a0364f59b2",
        "storage_key": "property/6767906449167514/019e46e4-092f-71b9-aa62-31a0364f59b2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkYtop0343YcRLPEglO826xI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_3def447e-af72-464d-bcb1-2f294ba086ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "Simply Lovely Salon",
      "poi_type": "Health and Wellness",
      "poi_address": "3825 Maine St Suite B, Quincy, IL 62305, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-f3af-721c-b675-007435f07093.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-f3af-721c-b675-007435f07093",
        "storage_key": "property/6767906449167514/019e46e3-f3af-721c-b675-007435f07093.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.simplylovelysalon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2671670905461388015&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "simply-lovely-salon",
      "poi_latitude": "39.9319732",
      "poi_longitude": "-91.3533639",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 217-641-2555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-092f-71b9-aa62-31a0364f59b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-092f-71b9-aa62-31a0364f59b2",
        "storage_key": "property/6767906449167514/019e46e4-092f-71b9-aa62-31a0364f59b2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvwi8Jor33YcR77LFjIiuEyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_b5b82f85-194a-4f20-961e-729a022cd47a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "Blessing Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1005 Broadway St, Quincy, IL 62301, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-f2ff-7155-931a-84d2bc4e82ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-f2ff-7155-931a-84d2bc4e82ba",
        "storage_key": "property/6767906449167514/019e46e3-f2ff-7155-931a-84d2bc4e82ba.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.blessinghealth.org/?utm_source=extnet&utm_medium=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=10092412521819194602&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "blessing-hospital",
      "poi_latitude": "39.9372286",
      "poi_longitude": "-91.3994301",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 217-223-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-08f1-737a-87c7-2428555090a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-08f1-737a-87c7-2428555090a2",
        "storage_key": "property/6767906449167514/019e46e4-08f1-737a-87c7-2428555090a2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJB5nhn1b33YcR6sS8ebdzD4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_16804f4d-bc2e-4a7a-a277-ec11eeeb42be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "Illinois Veterans Home",
      "poi_type": "Health and Wellness",
      "poi_address": "1707 N 12th St, Quincy, IL 62301, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-f624-7769-98b8-f3bc4ab992cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-f624-7769-98b8-f3bc4ab992cb",
        "storage_key": "property/6767906449167514/019e46e3-f624-7769-98b8-f3bc4ab992cb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.quincyivh.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10678673357916743266&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "illinois-veterans-home",
      "poi_latitude": "39.95400120000001",
      "poi_longitude": "-91.4019857",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 217-222-8641",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-0925-740c-98cb-6c0155c9558a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-0925-740c-98cb-6c0155c9558a",
        "storage_key": "property/6767906449167514/019e46e4-0925-740c-98cb-6c0155c9558a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ0s8W8r33YcRYiYOS9dEMpQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_eefda758-b3ab-463a-ba4f-257a9ab579f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "Moorman Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Quincy, IL 62305, USA",
      "poi_short_description": "Park, also featuring a playground, for baseball, basketball and volleyball games, plus picnic spots and miniature golf.",
      "poi_long_description": "People say this park offers a variety of activities, including paddleboats, pickleball courts, batting cages, play areas, picnic areas, and an 18-hole disc golf course. They highlight the beautiful scenery, the avenue of lights, and the family-friendly atmosphere. They also like the availability of mini golf and volleyball.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-f43e-75d7-a697-cfa90087d7ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-f43e-75d7-a697-cfa90087d7ca",
        "storage_key": "property/6767906449167514/019e46e3-f43e-75d7-a697-cfa90087d7ca.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.quincyparkdistrict.com/parks/moorman",
      "poi_directions_map_url": "https://maps.google.com/?cid=14970846491058399524&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "moorman-park",
      "poi_latitude": "39.9490109",
      "poi_longitude": "-91.3505411",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-08fc-701d-b68d-f80156de7a67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-08fc-701d-b68d-f80156de7a67",
        "storage_key": "property/6767906449167514/019e46e4-08fc-701d-b68d-f80156de7a67.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJYyd5jz743YcRJGlwjpAhw88",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_18a8bd62-451d-41ff-8972-37df2ba15a93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "Bob Mays Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2533 N 18th St, Quincy, IL 62305, USA",
      "poi_short_description": "Sprawling green space for kids and adults alike: playground, trails and fields plus picnic tables for lunch on the go.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-f42a-770c-82e7-7eec87dcb385.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-f42a-770c-82e7-7eec87dcb385",
        "storage_key": "property/6767906449167514/019e46e3-f42a-770c-82e7-7eec87dcb385.webp",
        "width": 600,
        "height": 486
      },
      "poi_business_url": "https://www.quincyparkdistrict.com/parks-and-facilities/bob-mays/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1646009885948798766&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bob-mays-park",
      "poi_latitude": "39.960319",
      "poi_longitude": "-91.388924",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 217-223-7703",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-08fc-701d-b68d-f80156de7a67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-08fc-701d-b68d-f80156de7a67",
        "storage_key": "property/6767906449167514/019e46e4-08fc-701d-b68d-f80156de7a67.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ47cqDFX33YcRLmfCNEXN1xY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3d64b774-1c4e-4359-938a-3efb449dbc9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "Westview Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2150 S 36th St, Quincy, IL 62301, USA",
      "poi_short_description": "Public golf course featuring well-placed bunkers, and accommodating to junior golfers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-f54f-747c-942b-b4c38e4f7b1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-f54f-747c-942b-b4c38e4f7b1c",
        "storage_key": "property/6767906449167514/019e46e3-f54f-747c-942b-b4c38e4f7b1c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://westviewgolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8977037478926372302&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "westview-golf-course",
      "poi_latitude": "39.9059012",
      "poi_longitude": "-91.3593703",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 217-223-7499",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-0b56-756b-8cb1-126d952a58f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-0b56-756b-8cb1-126d952a58f9",
        "storage_key": "property/6767906449167514/019e46e4-0b56-756b-8cb1-126d952a58f9.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJkTQIo-H53YcRzk3GUgbYlHw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_1bff279f-766d-4f58-9eb1-ee98e405756b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "Bill Klingner Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2533 N 18th St, Quincy, IL 62305, USA",
      "poi_short_description": "Open space featuring a disc-golf course, walking trails & a playground in a picturesque setting.",
      "poi_long_description": "People say this trail offers a long, paved path suitable for walking and biking, with good views along the waterline. They also highlight the well-maintained nature of the trail and the friendly atmosphere among visitors. Others mention the presence of a playground, making it a great spot for families.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-f4e6-757b-be5a-0f19344f0318.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-f4e6-757b-be5a-0f19344f0318",
        "storage_key": "property/6767906449167514/019e46e3-f4e6-757b-be5a-0f19344f0318.webp",
        "width": 420,
        "height": 280
      },
      "poi_business_url": "http://www.quincyparkdistrict.com/parks/bob-mays",
      "poi_directions_map_url": "https://maps.google.com/?cid=18197600093516490610&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bill-klingner-trail",
      "poi_latitude": "39.9581041",
      "poi_longitude": "-91.387579",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 217-223-7703",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-08fc-701d-b68d-f80156de7a67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-08fc-701d-b68d-f80156de7a67",
        "storage_key": "property/6767906449167514/019e46e4-08fc-701d-b68d-f80156de7a67.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQZa5C8P33YcRcmequt7civw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_78464117-934b-4d6e-82a4-a432234ce5f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "Lincoln Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1231 Bonansinga Dr, Quincy, IL 62305, USA",
      "poi_short_description": "Local outdoor park with a playground as well as a skate park and swings.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-f86f-70a8-a7c4-cec5f2b6470a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-f86f-70a8-a7c4-cec5f2b6470a",
        "storage_key": "property/6767906449167514/019e46e3-f86f-70a8-a7c4-cec5f2b6470a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.quincyparkdistrict.com/parks-and-facilities/lincoln-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12712230167566868069&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lincoln-park",
      "poi_latitude": "39.94601",
      "poi_longitude": "-91.4168699",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 217-223-7703",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-08fc-701d-b68d-f80156de7a67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-08fc-701d-b68d-f80156de7a67",
        "storage_key": "property/6767906449167514/019e46e4-08fc-701d-b68d-f80156de7a67.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-SNzKUT23YcRZd7TMPzparA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_adbf5411-0410-4baa-b3fd-27b572b25ac2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "Quincy",
      "poi_type": "Transportation & Transit",
      "poi_address": "Wisman Ln, Quincy, IL 62301, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-fd25-76bc-a2cd-62d6a09addfe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-fd25-76bc-a2cd-62d6a09addfe",
        "storage_key": "property/6767906449167514/019e46e3-fd25-76bc-a2cd-62d6a09addfe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/stations/qcy",
      "poi_directions_map_url": "https://maps.google.com/?cid=16716677790939191972&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "quincy",
      "poi_latitude": "39.9570106",
      "poi_longitude": "-91.3685263",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-0b60-7589-80ee-7fc6f68d1c98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-0b60-7589-80ee-7fc6f68d1c98",
        "storage_key": "property/6767906449167514/019e46e4-0b60-7589-80ee-7fc6f68d1c98.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJdykTzfX33YcRpJqX0eGR_ec",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_53a0b7fa-41f8-4c63-b804-4a086fe76d8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "Niemann Foods, Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1501 N 12th St, Quincy, IL 62301, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-f939-764e-9d41-66e2c79b4de3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-f939-764e-9d41-66e2c79b4de3",
        "storage_key": "property/6767906449167514/019e46e3-f939-764e-9d41-66e2c79b4de3.webp",
        "width": 1280,
        "height": 792
      },
      "poi_business_url": "http://www.mycountymarket.com/company/about-us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13182624868252896272&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "niemann-foods-inc",
      "poi_latitude": "39.9496552",
      "poi_longitude": "-91.3972032",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 217-221-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-092f-71b9-aa62-31a0364f59b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-092f-71b9-aa62-31a0364f59b2",
        "storage_key": "property/6767906449167514/019e46e4-092f-71b9-aa62-31a0364f59b2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR6gYB7f33YcREMxxH3kX8rY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_f2a548f5-569d-4354-9cd7-bda5a6dee403",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "ADM Animal Nutrition",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1000 N 30th St, Quincy, IL 62301, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-fcc6-7199-8873-61f7d45bd8e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-fcc6-7199-8873-61f7d45bd8e9",
        "storage_key": "property/6767906449167514/019e46e3-fcc6-7199-8873-61f7d45bd8e9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://admani.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11451338424431554826&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "adm-animal-nutrition",
      "poi_latitude": "39.9433631",
      "poi_longitude": "-91.3669586",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 217-222-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-092f-71b9-aa62-31a0364f59b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-092f-71b9-aa62-31a0364f59b2",
        "storage_key": "property/6767906449167514/019e46e4-092f-71b9-aa62-31a0364f59b2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW_a09pXBA4cRCjEGD6BT654",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_24837bc8-138d-42db-a413-20844aab07fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "Blessing Health System",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1005 Broadway St, Quincy, IL 62301, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-0188-765a-b9f3-c5e88138a59c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e4-0188-765a-b9f3-c5e88138a59c",
        "storage_key": "property/6767906449167514/019e46e4-0188-765a-b9f3-c5e88138a59c.webp",
        "width": 1280,
        "height": 782
      },
      "poi_business_url": "http://www.blessinghealth.org/?utm_source=extnet&utm_medium=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=12390917969008503034&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "blessing-health-system",
      "poi_latitude": "39.9370375",
      "poi_longitude": "-91.3995443",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 217-223-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-092f-71b9-aa62-31a0364f59b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-092f-71b9-aa62-31a0364f59b2",
        "storage_key": "property/6767906449167514/019e46e4-092f-71b9-aa62-31a0364f59b2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd7NnVN9G3ocR-qjBLz5i9as",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_85ca8300-a22e-49b4-a579-493715ee691a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "Titan Wheel International",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2801 Cherry St, Quincy, IL 62301, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-fcae-7518-ae2b-8800d8007c28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-fcae-7518-ae2b-8800d8007c28",
        "storage_key": "property/6767906449167514/019e46e3-fcae-7518-ae2b-8800d8007c28.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.titan-intl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16958484741614681901&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "titan-wheel-international",
      "poi_latitude": "39.9454131",
      "poi_longitude": "-91.3713198",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 217-228-6011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-092f-71b9-aa62-31a0364f59b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-092f-71b9-aa62-31a0364f59b2",
        "storage_key": "property/6767906449167514/019e46e4-092f-71b9-aa62-31a0364f59b2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP54gNR333YcRLT_TyAWkWOs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_345c2ace-bcae-445b-9eee-37fa762a4f10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "poi_name": "Phibro Animal Health",
      "poi_type": "Major Employers & Offices",
      "poi_address": "229 Radio Rd, Quincy, IL 62305, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e3-fd29-7004-b13b-a3a38baefd6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e46e3-fd29-7004-b13b-a3a38baefd6c",
        "storage_key": "property/6767906449167514/019e46e3-fd29-7004-b13b-a3a38baefd6c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.pahc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10923163462340986824&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "phibro-animal-health",
      "poi_latitude": "39.8924481",
      "poi_longitude": "-91.412639",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 217-222-8854",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e4-092f-71b9-aa62-31a0364f59b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e46e4-092f-71b9-aa62-31a0364f59b2",
        "storage_key": "property/6767906449167514/019e46e4-092f-71b9-aa62-31a0364f59b2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP30u8tP23YcRyEdcrEvflpc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_ca8b7fbcd80aa5f49315acb5",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_9d86e53c87a86f512aa6074a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_9e07897f4671e65e1fbe4780",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_c6199ea20b31423c7e229e38",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_9e7dc3a5b66e23b6f2fa9060",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_ec0fc270-f263-4604-b1ff-6f2f3cb6b30c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "rating": "5.0",
      "name": "Paranormal Google Reviews",
      "text": "Hello,\nI have lived here for over 2 years and it has been a great experience for the most part. The current Manager Christina is amazing and is super helpful when it comes to issues. Really easy to talk to about an issues that arise. We had issues with previous landlords but now this has been an overall good experience. Only complaint that I really have is the drive is in bad shape both on the hill and around the complex. The pool is never in service and gross looking. But the overall experience here has been good.",
      "date": "2019-09-16",
      "title": "false"
    },
    {
      "id": "custom_d9542b97-59fb-4f67-8114-512a9d95dd5e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "rating": "5.0",
      "name": "WD Bowen",
      "text": "Curb appeal is the cleanliness  of landscape and buildings. I can appreciate property under these conditions.",
      "date": "2023-09-21",
      "title": ""
    },
    {
      "id": "custom_1c37fdd4-a036-4580-b8b9-06da1a046752",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "rating": "5.0",
      "name": "Tracy Hagen",
      "text": "Angela worked hard to help my kids get their first apartment...things didn't go as smoothly as we hoped but she had patience enough to help us through it and was very kind.",
      "date": "2025-08-18",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_5783ba53-7337-49e8-952c-da8533d77253",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e6-3623-746d-8afa-d53fd6464d7b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e46e6-3623-746d-8afa-d53fd6464d7b",
        "storage_key": "property/6767906449167514/019e46e6-3623-746d-8afa-d53fd6464d7b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "3BR, 2BA - 1140 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=yMX5aAcvRms"
    },
    {
      "id": "custom_e35da78a-2011-4d51-a373-f77c75f02b31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167514/019e46e6-3626-764c-b04d-e4347f370e8f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e46e6-3626-764c-b04d-e4347f370e8f",
        "storage_key": "property/6767906449167514/019e46e6-3626-764c-b04d-e4347f370e8f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - 960 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=eaD2Gbtisrg"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019ed0ea-ca93-73ad-a0c7-1ecaaca3398c",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Cedar Creek Crossing Apartments Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514"
    },
    {
      "lead_collector_id": "019ed0ea-cb34-733a-b366-7c7dce17533b",
      "lead_source": "LANDING_PAGE",
      "name": "Cedar Creek Crossing Apartments Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-quincy-il",
      "search_query": "three bedroom apartments Quincy IL",
      "category": "Amenity",
      "h1_title": "Three Bedroom Apartments in Quincy, IL",
      "h2_subtitle": "Explore spacious three bedroom apartments in Quincy, IL. Cedar Creek Crossing offers the ideal blend of comfort and convenience.",
      "page_copy": "Discover the perfect living space at Cedar Creek Crossing with our inviting three-bedroom apartments in Quincy, IL. Designed with your needs in mind, our spacious floor plans offer an exceptional living experience complete with modern amenities and a professional on-site management team. Located in the heart of Quincy, these apartments ensure comfort and convenience in a well-connected community.\n\nNestled in Adams County, Cedar Creek Crossing offers premium city living. Our three-bedroom apartments provide ample room to create a home that fits your lifestyle. Whether hosting gatherings or enjoying a quiet evening at home, our community supports a variety of living needs while maintaining a welcoming atmosphere. With a range of amenities and a dedicated management staff, Cedar Creek Crossing delivers contemporary living at its best in Quincy, IL.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Quincy, IL",
      "seo_description": "Explore three bedroom apartments in Quincy, IL at Cedar Creek Crossing. Spacious living with modern amenities and professional on-site management.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "page_item_url": "spacious-floor-plans-adams-county",
      "search_query": "spacious floor plans Adams County",
      "category": "Amenity",
      "h1_title": "Spacious Floor Plans in Adams County",
      "h2_subtitle": "Discover spacious floor plans in Adams County at Cedar Creek Crossing. ",
      "page_copy": "At Cedar Creek Crossing, we offer spacious floor plans in Adams County that are thoughtfully designed to provide comfort and style. Our two- and three-bedroom layouts are crafted to meet a variety of living needs, offering flexibility for different lifestyles and space requirements. Every apartment is engineered to maximize both convenience and comfort, ensuring you feel at home from day one.\n\nEnjoy the benefits of living in Quincy without sacrificing space or amenities. Cedar Creek Crossing places you at the heart of city life while maintaining a peaceful residential atmosphere. Our professional on-site management staff is always ready to assist you, creating a well-managed and welcoming community. Experience modern living with spacious comfort in the vibrant setting of Adams County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Floor Plans in Adams County",
      "seo_description": "Cedar Creek Crossing offers spacious floor plans in Adams County. Experience comfortable living with ample space and community-focused amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "page_item_url": "professional-on-site-management-quincy",
      "search_query": "professional on‑site management Quincy",
      "category": "Amenity",
      "h1_title": "Professional On-Site Management in Quincy",
      "h2_subtitle": "Experience professional on-site management in Quincy at Cedar Creek Crossing. Our team is dedicated to providing a seamless living experience.",
      "page_copy": "At Cedar Creek Crossing, we pride ourselves on offering professional on-site management in Quincy that ensures residents enjoy a smooth, hassle-free living experience. Our dedicated management team is always on hand, ready to support our community with exceptional service and a personal touch. From maintaining our beautiful grounds to handling requests promptly, we're committed to keeping your home comfortable and secure.\n\nLocated in Adams County, our property not only offers modern two and three bedroom apartments but also a management team that goes the extra mile. Our residents enjoy peace of mind knowing that their needs are being taken seriously, fostering an environment of trust and satisfaction. Come and experience the benefits of a well-managed community at Cedar Creek Crossing.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Professional On-Site Management in Quincy",
      "seo_description": "Cedar Creek Crossing offers professional on-site management in Quincy, IL. Enjoy seamless living with our dedicated management team.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "page_item_url": "apartments-near-shopping-dining-62305",
      "search_query": "apartments near shopping and dining 62305",
      "category": "Amenity",
      "h1_title": "Apartments Near Shopping and Dining 62305",
      "h2_subtitle": "Find apartments near shopping and dining in the 62305 area. Cedar Creek Crossing places you close to Quincy's finest attractions.",
      "page_copy": "Cedar Creek Crossing's prime location in Quincy, IL, offers residents the convenience of living close to a variety of shopping and dining options in the 62305 area. Our well-appointed apartments provide easy access to everything from local boutiques to popular restaurants, making it simple to enjoy the best of Quincy's lifestyle. Whether you're looking to dine out or shop for essentials, you'll appreciate the nearby amenities that enhance your living experience.\n\nOur community is designed to cater to residents' needs with modern two and three bedroom floor plans and a host of amenities. Cedar Creek Crossing not only provides convenient access to Quincy's vibrant dining and shopping scene but also ensures a comfortable and fulfilling home environment. With professional, on-site management always available, you can enjoy the best of both worlds in this dynamic community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Shopping and Dining 62305",
      "seo_description": "Explore Cedar Creek Crossing's apartments near shopping and dining in the 62305 area. Enjoy proximity to Quincy's lifestyle attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-quincy-il",
      "search_query": "two bedroom apartments quincy il",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Quincy, IL",
      "h2_subtitle": "Explore comfortable two bedroom apartments in Quincy, IL. Cedar Creek Crossing offers spacious living with modern amenities.",
      "page_copy": "Cedar Creek Crossing in Quincy, IL, features thoughtfully designed two-bedroom apartments offering generous living spaces and modern conveniences for a comfortable and efficient home environment. Each apartment is crafted to provide natural light and ample storage, supporting practical everyday living.\n\nNestled in the vibrant community of Quincy, our property ensures residents are close to essential services, dining, and entertainment venues. With a professional on-site management team committed to excellence, Cedar Creek Crossing offers a well-maintained and welcoming living environment. Explore our two-bedroom options and discover what makes Cedar Creek Crossing a great place to call home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Quincy, IL",
      "seo_description": "Discover two bedroom apartments in Quincy, IL, at Cedar Creek Crossing, featuring spacious living areas and easy access to local amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-adams-county",
      "search_query": "three bedroom apartments in adams county",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Adams County",
      "h2_subtitle": "Discover spacious three bedroom apartments in Adams County at Cedar Creek Crossing. ",
      "page_copy": "Cedar Creek Crossing offers spacious three-bedroom apartments in Adams County, designed to meet a variety of living needs or those seeking extra space. These well-planned floor plans provide an abundance of room, offering flexibility for different household types. Each apartment is equipped with modern amenities, high-quality finishes, and plenty of natural light.\n\nLocated in Quincy, IL, our community ensures residents have access to an array of services and entertainment venues nearby. With a professional on-site management team dedicated to providing exceptional service, Cedar Creek Crossing is a comfortable and well-maintained place to call home in Adams County. Experience community living with ample space in our three-bedroom offerings.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Adams County",
      "seo_description": "Explore Cedar Creek Crossing’s three-bedroom apartments in Adams County with spacious layouts ideal for flexible living and shared living arrangements.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "page_item_url": "apartments-near-quincy-university",
      "search_query": "apartments near Quincy University in Quincy IL",
      "category": "School",
      "h1_title": "Apartments Near Quincy University",
      "h2_subtitle": "Find convenient apartments near Quincy University. Cedar Creek Crossing provides easy access and a pleasant living experience.",
      "page_copy": "Cedar Creek Crossing offers apartments near Quincy University in Quincy, IL, with convenient access to campus and surrounding amenities. Our community provides spacious two- and three-bedroom floor plans equipped with modern features that support comfortable everyday living.\n\nLocated just a short drive from Quincy University, Cedar Creek Crossing offers a well-connected location with a peaceful residential atmosphere. Our professional on-site management team is dedicated to maintaining a well-kept community. Enjoy convenient access to Quincy University while benefiting from comfortable apartment living in Quincy, IL.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Quincy University, Quincy, IL",
      "seo_description": "Cedar Creek Crossing offers apartments near Quincy University, combining convenience with comfort in Quincy, IL.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "page_item_url": "apartments-close-to-john-wood-community-college",
      "search_query": "apartments close to John Wood Community College 62305",
      "category": "School",
      "h1_title": "Apartments Near John Wood Community College",
      "h2_subtitle": "Discover apartments close to John Wood Community College in 62305. Cedar Creek Crossing provides convenient and comfortable living options.",
      "page_copy": "Situated conveniently close to John Wood Community College, Cedar Creek Crossing in Quincy, IL, offers a well-located option for those seeking proximity to campus and nearby amenities. Our community features spacious, modern two- and three-bedroom apartments designed for comfortable everyday living.\n\nLiving at Cedar Creek Crossing means you are minutes from campus and surrounding conveniences, making daily travel simple and efficient. Alongside its prime location, our property features a professional on-site management team committed to maintaining a welcoming and well-kept community. Experience comfortable apartment living in Quincy, IL near John Wood Community College.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near John Wood Community College 62305",
      "seo_description": "Cedar Creek Crossing offers comfortable living near John Wood Community College in Quincy, IL, 62305.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "page_item_url": "apartments-near-jwcc-workforce-development-center",
      "search_query": "apartments near JWCC Workforce Development Center Adams County",
      "category": "School",
      "h1_title": "Apartments Near JWCC Workforce Center",
      "h2_subtitle": "Explore apartments near the JWCC Workforce Development Center in Adams County. Cedar Creek Crossing is conveniently located for easy access.",
      "page_copy": "Located in Adams County, Cedar Creek Crossing provides a convenient residential option near the JWCC Workforce Development Center. Our apartment community features spacious two- and three-bedroom floor plans designed for comfortable everyday living.\n\nWith a prime location near local employers, schools, and services, commuting is quick and accessible, allowing residents to focus on their daily priorities. Cedar Creek Crossing’s on-site management team helps maintain a well-kept and welcoming community. Discover convenient apartment living in Quincy, IL near the Workforce Development Center.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near JWCC Workforce Center, Adams County",
      "seo_description": "Find ease and comfort at Cedar Creek Crossing, offering apartments near JWCC Workforce Development Center in Adams County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "page_item_url": "apartments-near-illinois-veterans-home-quincy",
      "search_query": "apartments near Illinois Veterans Home Quincy",
      "category": "Hospital",
      "h1_title": "Apartments Near Illinois Veterans Home",
      "h2_subtitle": "Explore apartments near Illinois Veterans Home in Quincy. Cedar Creek Crossing offers comfort and convenience close to the facility.",
      "page_copy": "Cedar Creek Crossing offers a convenient residential option near the Illinois Veterans Home in Quincy, IL. Our spacious two- and three-bedroom floor plans provide comfortable living with easy access to nearby services and community resources.\n\nLocated in a well-connected area of Quincy, residents benefit from proximity to local amenities, employers, and essential services. Our professional on-site management team is committed to maintaining a welcoming and well-kept community. Cedar Creek Crossing offers comfortable apartment living in Adams County with convenient access to the surrounding area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Illinois Veterans Home, Quincy",
      "seo_description": "Cedar Creek Crossing offers comfortable living options near Illinois Veterans Home in Quincy, IL, providing convenience and accessibility.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "page_item_url": "apartments-near-moorman-park-quincy-il",
      "search_query": "apartments near Moorman Park Quincy IL",
      "category": "Park",
      "h1_title": "Apartments Near Moorman Park Quincy IL",
      "h2_subtitle": "Discover apartments near Moorman Park in Quincy, IL. Cedar Creek Crossing provides a perfect balance of nature and city living.",
      "page_copy": "Nestled in Quincy, IL, Cedar Creek Crossing offers an appealing residential option for those who love proximity to outdoor activities. Our community is just a short drive from Moorman Park, making it the perfect location for nature enthusiasts looking for apartments nearby.\n\nEnjoy spacious two and three bedroom apartments designed for comfort, with the added convenience of being near one of the city's favorite green spaces. Our professional, on-site management team is dedicated to providing a welcoming environment, ensuring you can relax and savor the balance of park-side living and urban convenience at Cedar Creek Crossing.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Moorman Park Quincy, IL",
      "seo_description": "Live near nature at Cedar Creek Crossing, offering convenient apartments near Moorman Park in Quincy, IL.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "page_item_url": "cedar-creek-crossing-bob-mays-park-nearby",
      "search_query": "Cedar Creek Crossing Bob Mays Park nearby",
      "category": "Park",
      "h1_title": "Cedar Creek Crossing Near Bob Mays Park",
      "h2_subtitle": "Enjoy living at Cedar Creek Crossing with Bob Mays Park nearby. Experience the best of Quincy, IL's natural beauty right at your doorstep.",
      "page_copy": "Cedar Creek Crossing is superbly situated for those who crave the outdoors, with Bob Mays Park just a stone's throw away. This ideal location allows residents to enjoy a diverse array of recreational activities without straying far from home. Whether your passion is hiking, picnicking, or simply soaking up the sun, Bob Mays Park offers a peaceful retreat from your busy weekdays.\n\nOur two and three bedroom apartments are complemented by an on-site professional management team, ensuring you enjoy a seamless living experience at Cedar Creek Crossing. Embrace the tranquility of park-side living in Quincy while having quick access to urban amenities. Make Cedar Creek Crossing your home and discover the balance of comfort and nature right here in Adams County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cedar Creek Crossing with Bob Mays Park Nearby",
      "seo_description": "Find your home at Cedar Creek Crossing, conveniently located near Bob Mays Park in Quincy, IL, offering park-side comfort and city convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "page_item_url": "quincy-apartments-close-to-bill-klingner-trail",
      "search_query": "Quincy apartments close to Bill Klingner Trail",
      "category": "Park",
      "h1_title": "Quincy Apartments Close to Bill Klingner Trail",
      "h2_subtitle": "Discover apartments in Quincy close to the Bill Klingner Trail. Cedar Creek Crossing offers the perfect setting for outdoor enthusiasts.",
      "page_copy": "If you're searching for Quincy apartments close to the Bill Klingner Trail, look no further than Cedar Creek Crossing. Our community offers a serene living environment with quick access to this scenic trail, providing residents with endless opportunities for biking, walking, or simply enjoying the great outdoors.\n\nSpacious two and three bedroom floor plans ensure comfortable living, while our dedicated on-site management staff delivers exceptional support. Whether you delight in early morning trail runs or afternoon bike rides, Cedar Creek Crossing is your gateway to an active lifestyle. Enjoy the best of both nature and community living in a welcoming and conveniently located apartment complex.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Quincy Apartments Near Bill Klingner Trail",
      "seo_description": "Cedar Creek Crossing offers Quincy apartments conveniently close to Bill Klingner Trail, ideal for enjoying outdoor activities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167514",
      "source": "custom",
      "page_item_url": "apartments-near-lincoln-park-adams-county",
      "search_query": "apartments near Lincoln Park in Adams County",
      "category": "Park",
      "h1_title": "Apartments Near Lincoln Park, Adams County",
      "h2_subtitle": "Explore apartments near Lincoln Park in Adams County. Cedar Creek Crossing offers a vibrant lifestyle close to nature's beauty.",
      "page_copy": "Located in the heart of Adams County, Cedar Creek Crossing provides exceptional living with close proximity to Lincoln Park. Our community offers a tranquil setting with convenient access to nearby outdoor amenities, ideal for those who enjoy spending time in nature.\n\nOur two- and three-bedroom apartments feature modern designs and are managed by a professional on-site team dedicated to ensuring resident satisfaction. Imagine a home where the beauty and relaxation of Lincoln Park are within easy reach, allowing for a peaceful escape from daily routines. Choose Cedar Creek Crossing for an ideal blend of comfort and park-side living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Lincoln Park Adams County",
      "seo_description": "Discover Cedar Creek Crossing, offering comfortable apartments near Lincoln Park in Adams County, perfect for enjoying outdoor activities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12067682206"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5685512"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-5FH22FGR"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 3"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Prestige"
    },
    {
      "ID": "custom_tax_credit_properties",
      "type": "BOOLEAN",
      "value": "true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkZzOURaZCtxdU1lUDgzZjdJN1dsWmc9PSIsInZhbHVlIjoiZFZmVUlUZFFza29aVGZoRHJmS1BtZz09IiwibWFjIjoiZmYxM2FkYzg1YzhmNWEwNWFjZGI1NGFjODZjNzlhYmQzMzUwOWVlMDk0MWY2MmIxNDhkZDE4MmZmNzYwM2FhNiJ9"
    }
  ],
  "custom_repli_id": "12067682206",
  "custom_realpage_id": "5685512",
  "custom_google_gtm_id": "GTM-5FH22FGR",
  "custom_rollout_phase": "Phase 3",
  "custom_vibesites_theme": "Prestige",
  "custom_tax_credit_properties": "true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkZzOURaZCtxdU1lUDgzZjdJN1dsWmc9PSIsInZhbHVlIjoiZFZmVUlUZFFza29aVGZoRHJmS1BtZz09IiwibWFjIjoiZmYxM2FkYzg1YzhmNWEwNWFjZGI1NGFjODZjNzlhYmQzMzUwOWVlMDk0MWY2MmIxNDhkZDE4MmZmNzYwM2FhNiJ9",
  "custom_audioeye_site_id": "f5df2202-302c-4cee-ae18-bc3edc162e72",
  "custom_audioeye_site_hash": "55019aff922092837c1fbc44df76e880"
};

export const generatedAt = '2026-09-23T21:41:08.010Z';
